const langdict = [
  {
    id: 1, // QuickOrderV2.jsx, MainHeader.jsx
    data: [
      {
        no: 0,
        vi: "Chào mừng đến với Huế!",
        en: "Welcome Hue!",
        ko: "후에도시에 오신 것을 환영합니다",
      },
      {
        no: 1,
        vi: "Đặt vé tham quan trực tuyến thuận tiện, nhanh chóng.",
        en: "Book tickets online conveniently and quickly.",
        ko: "편리하고 빠른 전자입장권을 예매합니다",
      },
      {
        no: 2,
        vi: "Người lớn",
        en: "Adult",
        ko: "성인",
      },
      {
        no: 3,
        vi: "Trẻ em",
        en: "Children",
        ko: "어린이",
      },
      {
        no: 4,
        vi: "VNĐ",
        en: "VND",
        ko: "VND",
      },
      {
        no: 5,
        vi: "Điểm tham quan",
        en: "Sightseeing spot",
        ko: "방문 장소",
      },
      {
        no: 6,
        vi: "Trẻ em (Từ 7 - 12 tuổi)",
        en: "Children (7 - 12 years old)",
        ko: "어린이 (7세–12세)",
      },
      {
        no: 7,
        vi: "Mua vé",
        en: "Buy now",
        ko: "입장권 구매",
      },
      {
        no: 8,
        vi: "Lựa chọn...",
        en: "Choose...",
        ko: "선택...",
      },
      {
        no: 9,
        vi: "Nội quy tham gia",
        en: "Visitor regulation",
        ko: "관람 규칙",
      },
      {
        no: 10,
        vi: "Thời gian tham quan",
        en: "Visiting time",
        ko: "관람 시간",
      },
      {
        no: 11,
        vi: "Tra cứu vé",
        en: "Check the ticket",
        ko: "티켓 조회",
      },
    ],
  },
  {
    id: 2, // DatVeStep1Item.jsx
    data: [
      {
        no: 0,
        vi: "Từ",
        en: "From",
        ko: "부터",
      },
      {
        no: 1,
        vi: "VNĐ/Người",
        en: "VND/Person",
        ko: "VND/사람",
      },
    ],
  },
  {
    id: 3, // MuaVeStep3Item.jsx
    data: [
      {
        no: 0,
        vi: "Số lượng:",
        en: "Quantity:",
        ko: "수량:",
      },
      {
        no: 1,
        vi: "Tổng cộng",
        en: "Total",
        ko: "총 결제금액",
      },
      {
        no: 2,
        vi: "VNĐ",
        en: "VND",
        ko: "VND",
      },
    ],
  },
  {
    id: 4, // MuaVeStep3SubItem.jsx, BanVeStep3SubItem.jsx
    data: [
      {
        no: 0,
        vi: "Loại giấy tờ",
        en: "Type of ID",
        ko: "신분증 종류",
      },
      {
        no: 1,
        vi: "Tên khách",
        en: "Customer name",
        ko: "고객 이름",
      },
      {
        no: 2,
        vi: "Họ và tên",
        en: "Full name",
        ko: "성명",
      },
      {
        no: 3,
        vi: "Số giấy tờ",
        en: "ID card",
        ko: "신분증",
      },
      {
        no: 4,
        vi: "Ngày sinh",
        en: "Date of birth",
        ko: "생년월일",
      },
      {
        no: 5,
        vi: "Địa phương cư trú",
        en: "Province",
        ko: "지방",
      },
      {
        no: 6,
        vi: "Hãy chọn địa phương cư trú",
        en: "Province",
        ko: "지방",
      },
      {
        no: 7,
        vi: "Địa chỉ",
        en: "Address",
        ko: "주소",
      },
      {
        no: 8,
        vi: "Địa chỉ thường trú",
        en: "Address",
        ko: "주소",
      },
      {
        no: 9,
        vi: "Loại ưu tiên",
        en: "Priority type",
        ko: "우선순위 유형",
      },
      {
        no: 10,
        vi: "Ghi chú",
        en: "Note",
        ko: "메모",
      },
      {
        no: 11,
        vi: "File đính kèm",
        en: "Attached file",
        ko: "첨부 파일",
      },
      {
        no: 12,
        vi: "CCCD",
        en: "Citizen ID card",
        ko: "주민등록증",
      },
      {
        no: 13,
        vi: "Hộ chiếu",
        en: "Passport",
        ko: "여권",
      },
      {
        no: 14,
        vi: "Giấy phép LX",
        en: "Driver's license",
        ko: "운전면허증",
      },
      {
        no: 15,
        vi: "Khác",
        en: "Other",
        ko: "다른",
      },
      {
        no: 16,
        vi: "Đọc từ thẻ CCCD",
        en: "Read from the citizen ID card",
        ko: "주민등록증에서 읽다",
      },
      {
        no: 17,
        vi: "Nhập thủ công",
        en: "Manual input",
        ko: "수동 입력",
      },
      {
        no: 18,
        vi: "Thêm thông tin CCCD",
        en: "Add national ID information",
        ko: "주민등록번호 정보를 추가하다",
      },
      {
        no: 19,
        vi: "Chọn tệp",
        en: "Choose file",
        ko: "파일 선택",
      },
      {
        no: 20,
        vi: "Không có tệp nào được chọn",
        en: "No file chosen",
        ko: "선택된 파일이 없습니다",
      },
      {
        no: 21,
        vi: "Chụp ảnh",
        en: "Take a photo",
        ko: "사진 찍기",
      },
      {
        no: 22,
        vi: "Mở camera",
        en: "Open camera",
        ko: "카메라 열기",
      },
      {
        no: 23,
        vi: "Cần chọn nút 'MỞ CAMERA' để chụp hình giấy tờ đính kèm",
        en: "Please select the 'OPEN CAMERA' button to take a photo of the attached document",
        ko: "첨부된 서류를 촬영하려면 '카메라 열기' 버튼을 선택하세요",
      },
      {
        no: 24,
        vi: "Chọn nút này để chụp hình",
        en: "Select this button to take a photo",
        ko: "사진을 촬영하려면 이 버튼을 선택하세요",
      },
    ],
  },
  {
    id: 5, // RightSideBarThongTin.jsx
    data: [
      {
        no: 0,
        vi: "Thông tin",
        en: "Information",
        ko: "정보",
      },
      {
        no: 1,
        vi: "Thời gian tham quan",
        en: "Visiting time",
        ko: "관람 시간",
      },
      {
        no: 2,
        vi: "Nội quy",
        en: "Visitor regulation",
        ko: "관람 규칙",
      },
      {
        no: 3,
        vi: "Chương trình khuyến mãi",
        en: "Promotion",
        ko: "프로모션",
      },
      {
        no: 4,
        vi: "Chương trình Tour mới",
        en: "New tourist program",
        ko: "새로운 관광 프로그램",
      },
    ],
  },
  {
    id: 6, // QuantityTurningItem.jsx
    data: [
      {
        no: 0,
        vi: "",
        en: "",
        ko: "",
      },
    ],
  },
  {
    id: 7, // ThoiGianThamQuan.jsx
    data: [
      {
        no: 0,
        vi: "THỜI GIAN THAM QUAN",
        en: "Visiting time",
        ko: "관람 시간",
      },
    ],
  },
  {
    id: 8, // PrinciplePage.jsx
    data: [
      {
        no: 0,
        vi: "Nội quy tham quan",
        en: "Visitor regulation",
        ko: "관람 규칙",
      },
    ],
  },
  {
    id: 9, // DiemDenChiTietPage.jsx
    data: [
      {
        no: 0,
        vi: "Xem vị trí trên bản đồ",
        en: "View location on the map",
        ko: "지도에서 위치 보기",
      },
    ],
  },
  {
    id: 10, // DatVeStep1.jsx
    data: [
      {
        no: 0,
        vi: "Chọn điểm di tích",
        en: "Select relic point",
        ko: "유적지 선택",
      },
      {
        no: 1,
        vi: "Mua vé",
        en: "Buy tickets",
        ko: "입장권 구매하기",
      },
      {
        no: 2,
        vi: "Thanh toán",
        en: "Pay",
        ko: "결제",
      },
      {
        no: 3,
        vi: "Hoàn tất",
        en: "Completed",
        ko: "완료",
      },
      {
        no: 4,
        vi: "Tìm điểm đến...",
        en: "Find your destination...",
        ko: "목적지 찾기...",
      },
      {
        no: 5,
        vi: "Giá vé:",
        en: "Ticket price:",
        ko: "입장권 가격:",
      },
      {
        no: 6,
        vi: "Từ",
        en: "From",
        ko: "부터",
      },
      {
        no: 7,
        vi: "VNĐ/Người",
        en: "VND/Person",
        ko: "VND/인당",
      },
      {
        no: 8,
        vi: "Mua ngay",
        en: "Buy now",
        ko: "지금 구매",
      },
    ],
  },
  {
    id: 11, // DatVeStep2.jsx, DatVeStep2GioHang.jsx, SectionGioHang.jsx, SectionGioHangItem.jsx, SoLuongVeTheoLoaiDoiTuong.jsx, SoLuongVeTheoLoaiDoiTuongChiTiet.jsx
    data: [
      {
        no: 0,
        vi: "Chọn điểm di tích",
        en: "Select relic point",
        ko: "유적지 선택",
      },
      {
        no: 1,
        vi: "Mua vé",
        en: "Buy tickets",
        ko: "입장권 구매하기",
      },
      {
        no: 2,
        vi: "Thanh toán",
        en: "Pay",
        ko: "결제",
      },
      {
        no: 3,
        vi: "Hoàn tất",
        en: "Completed",
        ko: "완료",
      },
      {
        no: 4,
        vi: "Khách tham quan",
        en: "Visitors",
        ko: "방문객",
      },
      {
        no: 5,
        vi: "Thông tin đặt vé",
        en: "Ticket booking information",
        ko: "티켓 예약 정보",
      },
      {
        no: 6,
        vi: "Số lượng:",
        en: "Quantity:",
        ko: "수량:",
      },
      {
        no: 7,
        vi: "Lưu ý: Nhóm ưu tiên chỉ áp dụng cho công dân Việt Nam",
        en: "Note: The priority group applies exclusively to Vietnamese citizens.",
        ko: "참고: 우대 대상은 베트남 국민에게만 적용됩니다",
      },
      {
        no: 8,
        vi: "Thông tin liên hệ",
        en: "Contact information",
        ko: "연락처 정보",
      },
      {
        no: 9,
        vi: "Bạn muốn xuất biên lai điện tử ngay?",
        en: "Want to issue electronic receipts now?",
        ko: "전자 영수증 즉시 발급 여부?",
      },
      {
        no: 10,
        vi: "Tên khách/đoàn tham quan",
        en: "Name of guest/tour group",
        ko: "방문객/방문 단체명",
      },
      {
        no: 11,
        vi: "Họ và tên",
        en: "Full name",
        ko: "성명",
      },
      {
        no: 12,
        vi: "Email",
        en: "Email",
        ko: "이메일",
      },
      {
        no: 13,
        vi: "Số điện thoại",
        en: "Phone number",
        ko: "전화번호",
      },
      {
        no: 14,
        vi: "Mã số thuế",
        en: "Tax code",
        ko: "세금 코드",
      },
      {
        no: 15,
        vi: "Địa chỉ",
        en: "Address",
        ko: "주소",
      },
      {
        no: 16,
        vi: "Lưu ý: Sử dụng số điện thoại và Email để tra cứu lại vé sau khi đã thanh toán thành công",
        en: "Note: Use your phone number and Email address to look up your ticket after a successful payment",
        ko: "참고: 결제가 완료되면 휴대폰 번호와 이메일 주소를 사용하여 티켓을 조회할 수 있습니다.",
      },
      {
        no: 17,
        vi: "Quốc tịch",
        en: "Nationality",
        ko: "국적",
      },
      {
        no: 18,
        vi: "Địa phương",
        en: "Province",
        ko: "지방",
      },
      {
        no: 19,
        vi: "Người nước ngoài",
        en: "Foreigner",
        ko: "외국인",
      },
      {
        no: 20,
        vi: "Tạm tính:",
        en: "Temporarily calculated:",
        ko: "금액:",
      },
      {
        no: 21,
        vi: "VNĐ",
        en: "VND",
        ko: "VND",
      },
      {
        no: 22,
        vi: "Khuyến mãi:",
        en: "Promotion:",
        ko: "프로모션:",
      },
      {
        no: 23,
        vi: "Tổng cộng:",
        en: "Total:",
        ko: "총 결제금액:",
      },
      {
        no: 24,
        vi: "Mua vé",
        en: "Buy tickets",
        ko: "입장권 구매하기",
      },
      {
        no: 25,
        vi: "Thông tin mua vé",
        en: "Ticket purchase information",
        ko: "티켓 구매 정보",
      },
      {
        no: 26,
        vi: "Bạn muốn xuất biên lai điện tử?",
        en: "Want to issue electronic receipts?",
        ko: "전자 영수증 즉시 발급 여부?",
      },
      {
        no: 27,
        vi: "Chọn tất cả",
        en: "Select all",
        ko: "모두 선택",
      },
      {
        no: 28,
        vi: "Đặt vé",
        en: "Book tickets",
        ko: "티켓 예약",
      },
      {
        no: 29,
        vi: "Tổng cộng",
        en: "Total",
        ko: "총 결제금액",
      },
      {
        no: 30,
        vi: "Xóa",
        en: "Delete",
        ko: "삭제",
      },
      {
        no: 31,
        vi: "Lựa chọn...",
        en: "Choose...",
        ko: "선택...",
      },
      {
        no: 32,
        vi: "Số lượng chi tiết",
        en: "Detail quantity",
        ko: "상세 수량",
      },
      {
        no: 33,
        vi: "Số lượng",
        en: "Quantity",
        ko: "수량",
      },
      {
        no: 34,
        vi: "Kích vào đây để xem chính sách miễn, giảm giá vé tham quan cho đối tượng ưu tiên",
        en: "Click here to view the discount and exemption policy for eligible visitors",
        ko: "우대 대상의 입장권 면제 및 할인 정책을 보려면 여기를 클릭하세요",
      },
    ],
  },
  {
    id: 12, // DatVeStep3.jsx, DatVeStep3GioHang.jsx
    data: [
      {
        no: 0,
        vi: "Chọn điểm di tích",
        en: "Select relic point",
        ko: "유적지 선택",
      },
      {
        no: 1,
        vi: "Mua vé",
        en: "Buy tickets",
        ko: "입장권 구매하기",
      },
      {
        no: 2,
        vi: "Thanh toán",
        en: "Pay",
        ko: "결제",
      },
      {
        no: 3,
        vi: "Hoàn tất",
        en: "Completed",
        ko: "완료",
      },
      {
        no: 4,
        vi: "Xác nhận thông tin",
        en: "Confirm information",
        ko: "정보 확인",
      },
      {
        no: 5,
        vi: "Tên khách/Đoàn tham quan:",
        en: "Name of guest/tour group:",
        ko: "방문객/방문 단체명:",
      },
      {
        no: 6,
        vi: "Email:",
        en: "Email:",
        ko: "이메일:",
      },
      {
        no: 7,
        vi: "Số điện thoại:",
        en: "Phone number:",
        ko: "전화번호:",
      },
      {
        no: 8,
        vi: "Mã số thuế:",
        en: "Tax code:",
        ko: "세금 코드:",
      },
      {
        no: 9,
        vi: "Địa chỉ:",
        en: "Address:",
        ko: "주소:",
      },
      {
        no: 10,
        vi: "Chọn phương thức thanh toán",
        en: "Select payment method",
        ko: "결제 방법 선택",
      },
      {
        no: 11,
        vi: "Thanh toán Online",
        en: "Online Payment",
        ko: "온라인 결제",
      },
      {
        no: 12,
        vi: "Chọn phương thức thanh toán",
        en: "Select payment method",
        ko: "결제 방법 선택",
      },
      {
        no: 13,
        vi: "Thanh toán online bằng mã QR",
        en: "Online payment by QR code",
        ko: "QR 코드를 스캔하여 결제하세요",
      },
      {
        no: 14,
        vi: "Thanh toán tại quầy",
        en: "Pay at the counter",
        ko: "카운터에서 결제",
      },
      {
        no: 15,
        vi: "Thanh toán",
        en: "Pay",
        ko: "결제",
      },
      {
        no: 16,
        vi: "Tạm tính:",
        en: "Temporarily calculated:",
        ko: "금액:",
      },
      {
        no: 17,
        vi: "VNĐ",
        en: "VND",
        ko: "VND",
      },
      {
        no: 18,
        vi: "Khuyến mãi:",
        en: "Promotion:",
        ko: "프로모션:",
      },
      {
        no: 19,
        vi: "Tổng cộng:",
        en: "Total:",
        ko: "총 결제금액:",
      },
      {
        no: 20,
        vi: "Thanh toán tiền mặt",
        en: "Cash payment",
        ko: "현금 결제",
      },
      {
        no: 21,
        vi: "Thanh toán",
        en: "Pay",
        ko: "결제",
      },
      {
        no: 22,
        vi: "Khi bạn nhấn nút <b>Thanh toán</b> là đồng ý Các điều khoản sử dụng của chúng tôi.",
        en: "By clicking the <b>Checkout</b> button you agree to our Terms of Use.",
        ko: "<b>‘결제’</b> 버튼을 누르면 이용 약관에 동의하는 것으로 간주됩니다",
      },
      {
        no: 23,
        vi: "<b>Quý khách lưu ý:</b> Vé đã thanh toán không được đổi trả.",
        en: "<b>Please note:</b> Paid tickets cannot be returned or exchanged.",
        ko: "<b>유의사항:</b> 결제 완료된 입장권은 환불 및 변경이 불가능합니다",
      },
      {
        no: 24,
        vi: "Họ tên",
        en: "Full name",
        ko: "성명",
      },
    ],
  },
  {
    id: 13, // DatVeStep4.jsx, DatVeHoanTat.jsx
    data: [
      {
        no: 0,
        vi: "Chọn điểm di tích",
        en: "Select relic point",
        ko: "유적지 선택",
      },
      {
        no: 1,
        vi: "Mua vé",
        en: "Buy tickets",
        ko: "입장권 구매하기",
      },
      {
        no: 2,
        vi: "Thanh toán",
        en: "Pay",
        ko: "결제",
      },
      {
        no: 3,
        vi: "Hoàn tất",
        en: "Completed",
        ko: "완료",
      },
      {
        no: 4,
        vi: "Đặt vé",
        en: "Book tickets",
        ko: "Book tickets",
      },
      {
        no: 5,
        vi: "Mua vé",
        en: "Ticket Purchase",
        ko: "입장권 구매하기",
      },
      {
        no: 6,
        vi: "MUA VÉ",
        en: "TICKET PURCHASE",
        ko: "입장권 구매하기",
      },
      {
        no: 7,
        vi: "ĐẶT VÉ",
        en: "BOOK TICKETS",
        ko: "티켓 예약",
      },
      {
        no: 8,
        vi: "(ĐÃ THANH TOÁN)",
        en: "(PAID)",
        ko: "(지불 완료)",
      },
      {
        no: 9,
        vi: "(CHƯA THANH TOÁN)",
        en: "(NOT PAID)",
        ko: "(미결제)",
      },
      {
        no: 10,
        vi: "Mua vé thành công",
        en: "Ticket purchase successful",
        ko: "티켓 구매 성공",
      },
      {
        no: 11,
        vi: "thành công",
        en: "successfully",
        ko: "성공적으로",
      },
      {
        no: 12,
        vi: "Yêu cầu",
        en: "Your",
        ko: "귀하의",
      },
      {
        no: 13,
        vi: "của bạn đã được thực hiện thành công",
        en: "request has been successfully completed",
        ko: "요청이 성공적으로 완료되었습니다",
      },
      {
        no: 14,
        vi: ". Bạn có thể kiểm tra thông tin chi tiết bên dưới.",
        en: ". You can check the details below.",
        ko: ". 아래에서 세부 정보를 확인할 수 있습니다.",
      },
      {
        no: 15,
        vi: "Cám ơn bạn đã tin tưởng và sử dụng dịch vụ của chúng tôi. Nếu có bất kì thắc mắc nào hay cần sự giúp đỡ, vui lòng liên hệ đến: <br />Trung tâm hỗ trợ ",
        en: "Thank you for trusting and using our service. If you have any questions or need help, please contact: <br />Our support center ",
        ko: "저희 서비스를 신뢰하고 이용해 주셔서 감사합니다. 궁금한 사항이 있거나 도움이 필요하시면, 아래의 지원 센터에 연락해 주세요: <br />우리 지원 센터 ",
      },
      {
        no: 16,
        vi: "0935966201",
        en: "0935966201",
        ko: "0935966201",
      },
      {
        no: 17,
        vi: "của chúng tôi để nhận được hướng dẫn. <br />Tra cứu hóa đơn đặt vé tại đây: <b><a href='https://eticket.hueworldheritage.org.vn/lich-su-mua-ve'>Tại đây</a></b>",
        en: "for instructions. <br />To check your ticket booking invoice, please visit the website: <b>https://eticket.hueworldheritage.org.vn/lich-su-mua-ve</b>",
        ko: "지침을 받으려면 저희에게 연락해 주세요. <br />티켓 예약 영수증을 확인하려면 아래 웹사이트를 방문해 주세요: <b>https://eticket.hueworldheritage.org.vn/lich-su-mua-ve</b>",
      },
      {
        no: 18,
        vi: "Vé chưa có giá trị sử dụng. Vui lòng thanh toán tại quầy hoặc thanh toán online thông qua liên kết được gửi qua email để vào tham quan",
        en: "Tickets are not yet valid. Please pay at the counter or pay online via the link sent via email to enter the tour.",
        ko: "티켓이 아직 유효하지 않습니다. 카운터에서 결제하거나 이메일로 전송된 링크를 통해 온라인 결제 후 투어에 참여해 주세요.",
      },
      {
        no: 19,
        vi: "Thông tin liên hệ",
        en: "Contact information",
        ko: "연락처 정보",
      },
      {
        no: 20,
        vi: "Họ tên:",
        en: "Full name:",
        ko: "성명:",
      },
      {
        no: 21,
        vi: "Email:",
        en: "Email:",
        ko: "이메일:",
      },
      {
        no: 22,
        vi: "Số điện thoại:",
        en: "Phone number:",
        ko: "전화번호:",
      },
      {
        no: 23,
        vi: "Thông tin đơn vé",
        en: "Ticket information",
        ko: "티켓 주문 정보",
      },
      {
        no: 24,
        vi: "Mã vé:",
        en: "Ticket code:",
        ko: "티켓 코드:",
      },
      {
        no: 25,
        vi: "Thời gian đặt:",
        en: "Set time:",
        ko: "예약 시간:",
      },
      {
        no: 26,
        vi: "Thanh toán:",
        en: "Pay:",
        ko: "결제:",
      },
      {
        no: 27,
        vi: "Máy POS",
        en: "POS machine",
        ko: "POS 기계",
      },
      {
        no: 28,
        vi: "Tiền mặt",
        en: "Cash",
        ko: "현금",
      },
      {
        no: 29,
        vi: "Chuyển khoản",
        en: "Transfer",
        ko: "이체",
      },
      {
        no: 30,
        vi: "Số tiền thanh toán:",
        en: "Payment amount:",
        ko: "결제 금액:",
      },
      {
        no: 31,
        vi: "VNĐ",
        en: "VND",
        ko: "VND",
      },
      {
        no: 32,
        vi: "Xem chi tiết",
        en: "See details",
        ko: "상세 보기",
      },
      {
        no: 33,
        vi: "Ẩn chi tiết",
        en: "Hide details",
        ko: "상세 숨기기",
      },
      {
        no: 34,
        vi: "Địa điểm:",
        en: "Location:",
        ko: "위치:",
      },
      {
        no: 35,
        vi: "Số lượng:",
        en: "Quantity:",
        ko: "수량:",
      },
      {
        no: 36,
        vi: "Tổng cộng:",
        en: "Total:",
        ko: "총 결제금액:",
      },
      {
        no: 37,
        vi: "Gửi vé vào email",
        en: "Send tickets to email",
        ko: "이메일로 티켓 보내기",
      },
      {
        no: 38,
        vi: "Nhập email...",
        en: "Enter email...",
        ko: "이메일 입력...",
      },
      {
        no: 39,
        vi: "Đăng nhập",
        en: "Sign in",
        ko: "로그인",
      },
      {
        no: 40,
        vi: "để lưu giữ thông tin vé! Nếu chưa có tài khoản?",
        en: "to save your ticket information! If you don't have an account yet?",
        ko: "티켓 정보를 저장하려면 로그인하세요! 계정이 없으신가요?",
      },
      {
        no: 41,
        vi: "Đăng ký",
        en: "Register",
        ko: "회원가입",
      },
      {
        no: 42,
        vi: "ĐÃ THANH TOÁN",
        en: "PAID",
        ko: "지불 완료",
      },
      {
        no: 43,
        vi: "In vé",
        en: "Print tickets",
        ko: "티켓 인쇄",
      },
      {
        no: 44,
        vi: "Tải biên lai",
        en: "Download receipt",
        ko: "영수증 다운로드",
      },
      {
          no: 45,
          vi: "Thuế VAT(8%):",
          en: "VAT:",
          ko: "큰 통:",
      },
      {
          no: 46,
          vi: "Tạm tính:",
          en: "Temporarily calculated:",
          ko: "임시 계산됨:",
      },
      {
          no: 47,
          vi: "Thời gian sự kiện:",
          en: "Event time:",
          ko: "이벤트 시간:",
      },
      {
          no: 48,
          vi: "Xem lại vé",
          en: "Check tickets",
          ko: "티켓 검토",
      },
      {
          no: 49,
          vi: "Thanh toán đã hoàn thành,",
          en: "Payment has been completed.",
          ko: "결제가 완료되었습니다."
      },
      {
          no: 50,
          vi: "Nếu cần hỗ trợ, liên hệ ",
          en: "If you need assistance, please contact us.",
          ko: "도움이 필요하시면 저희에게 연락주세요."
      },
      {
          no: 51,
          vi: " vui lòng kiểm tra thông tin vé bên dưới",
          en: " Please check the ticket information below.",
          ko: " 아래 티켓 정보를 확인해 주세요."
      },
      {
          no: 52,
          vi: " hoặc tra cứu <b><a href='https://eticket.hueworldheritage.org.vn/lich-su-mua-ve'>tại đây</a></b>",
          en: " or check <b><a href='https://eticket.hueworldheritage.org.vn/lich-su-mua-ve'>here</a></b>",
          ko: " 또는 <b><a href='https://eticket.hueworldheritage.org.vn/lich-su-mua-ve'>여기</a></b>를 확인하세요."
      }
    ],
  },
  {
    id: 14, // TicketQrModal.jsx, TicketQrModalItem.jsx, ConfirmModal.jsx, QrPayModal.jsx, ErrorModal.jsx
    data: [
      {
        no: 0,
        vi: "Danh sách vé",
        en: "Ticket list",
        ko: "티켓 목록",
      },
      {
        no: 1,
        vi: "trung tâm bảo tồn di tích cố đô huế",
        en: "Hue Monuments Conservation Centre",
        ko: "후에 유적 보존 센터",
      },
      {
        no: 2,
        vi: "Vé hướng dẫn viên",
        en: "Tour guide ticket",
        ko: "관광 가이드 티켓",
      },
      {
        no: 3,
        vi: "vé tham quan di tích",
        en: "Heritage site admission ticket",
        ko: "유적지 입장 티켓",
      },
      {
        no: 4,
        vi: "Số lượng:",
        en: "Quantity:",
        ko: "수량:",
      },
      {
        no: 5,
        vi: "Cám ơn quý khách",
        en: "Thank you!",
        ko: "감사합니다!",
      },
      {
        no: 6,
        vi: "eticket.hueworldheritage.org.vn",
        en: "eticket.hueworldheritage.org.vn",
        ko: "eticket.hueworldheritage.org.vn",
      },
      {
        no: 7,
        vi: "Mã vé:",
        en: "Code:",
        ko: "티켓 코드:",
      },
      {
        no: 8,
        vi: "Xác nhận",
        en: "Confirm",
        ko: "확인",
      },
      {
        no: 9,
        vi: "Hủy",
        en: "Close",
        ko: "닫기",
      },
      {
        no: 10,
        vi: "Quét mã QR để thanh toán",
        en: "Scan QR code to pay",
        ko: "QR 코드를 스캔하여 결제하세요",
      },
      {
        no: 11,
        vi: "Mã vé đồng thời được gửi về địa chỉ email của Quý khách.<br/>Hoặc tra cứu tại Thông tin/Tra cứu mã vé.",
        en: "The ticket code will also be sent to your email address.<br/>Or look up at Information/Check ticket code.",
        ko: "입장권 번호는 이메일로 전송되며, ‘정보 / 입장권 조회’에서도 확인할 수 있습니다",
      },
      {
        no: 12,
        vi: "Tải về máy",
        en: "Download to your device",
        ko: "다운로드",
      },
      {
        no: 13,
        vi: "",
        en: "",
        ko: "",
      },
      {
        no: 14,
        vi: "Vé có thời hạn ",
        en: "Ticket is valid for ",
        ko: "티켓은 ",
      },
      {
        no: 15,
        vi: "ngày, <br /> tính từ lần sử dụng đầu tiên  ",
        en: "days, <br /> starting from the first use",
        ko: "일간 유효하며, <br /> 최초 사용일로부터 계산됩니다",
      },
    ],
  },
  {
    id: 15, // DanhSachVe.jsx
    data: [
      {
        no: 0,
        vi: "Tìm mã đặt vé",
        en: "Find Booking Code",
        ko: "예매 코드 찾기",
      },
      {
        no: 1,
        vi: "Hãy nhập số điện thoại đã mua vé",
        en: "Please enter the phone number used to purchase tickets",
        ko: "티켓을 구매할 때 사용한 전화번호를 입력해 주세요",
      },
      {
        no: 2,
        vi: "Tìm kiếm",
        en: "Search",
        ko: "검색하다",
      },
      {
        no: 3,
        vi: "Danh sách vé",
        en: "Ticket List",
        ko: "티켓 목록",
      },
      {
        no: 4,
        vi: "Mã vé",
        en: "Ticket Code",
        ko: "티켓 코드",
      },
      {
        no: 5,
        vi: "Ngày mua",
        en: "Purchase Date",
        ko: "구매일",
      },
      {
        no: 6,
        vi: "Giờ mua",
        en: "Purchase Time",
        ko: "구매 시간",
      },
      {
        no: 7,
        vi: "Họ và tên",
        en: "Full name",
        ko: "성명",
      },
      {
        no: 8,
        vi: "Tổng tiền",
        en: "Total Amount",
        ko: "결제 금액",
      },
      {
        no: 9,
        vi: "Trạng thái",
        en: "Status",
        ko: "상태",
      },
      {
        no: 10,
        vi: "Chức năng",
        en: "Function",
        ko: "기능",
      },
      {
        no: 11,
        vi: "Lấy vé",
        en: "Get the ticket",
        ko: "티켓을 받다",
      },
      {
        no: 12,
        vi: "Chưa sử dụng",
        en: "Unused",
        ko: "미사용",
      },
      {
        no: 13,
        vi: "Đã sử dụng",
        en: "Used",
        ko: "사용함",
      },
      {
        no: 14,
        vi: "Đã hủy",
        en: "Cancelled",
        ko: "취소됨",
      },
      {
        no: 15,
        vi: "Không có dữ liệu",
        en: "No data available",
        ko: "데이터가 없습니다",
      },
      {
        no: 16,
        vi: "Hãy nhập email đã mua vé",
        en: "Please enter the email used to purchase tickets",
        ko: "티켓을 구매할 때 사용한 이메일을 입력해 주세요",
      },
      {
        no: 17,
        vi: "Nhập email để tra cứu vé",
        en: "Please enter your email to look up your tickets",
        ko: "이메일을 입력하여 티켓을 조회해 주세요",
      },
      {
        no: 18,
        vi: "Nhận mã OTP",
        en: "Get OTP",
        ko: "OTP 받기",
      },
    ],
  },
  {
    id: 16, // MenuDropdown.jsx
    data: [
      {
        no: 0,
        vi: "Bảng giá vé",
        en: "Price",
        ko: "티켓 가격표",
      },
    ],
  },
  {
    id: 17, // MainSlider.jsx
    data: [
      {
        no: 0,
        vi: "Đại Nội Huế",
        en: "Hue Imperial City",
        ko: "후에 황궁",
      },
      {
        no: 1,
        vi: "Người ta đến Huế không chỉ thưởng thức những cảnh đẹp lãng mạn, thơ mộng mà nơi đây còn lưu giữ vết tích Đại Nội Huế, chốn cung đình xưa cũ của triều đại nhà Nguyễn ở Việt Nam.",
        en: "Visitors come to Hue not only by its romantic and poetic landscapes, but also by the chance to explore the remnants of the Hue Imperial City — the former royal court of the Nguyen Dynasty in Viet Nam.",
        ko: "후에는 낭만적이고 시적인 풍경뿐만 아니라, 베트남 응우옌 왕조의 옛 왕실이었던 후에 황궁의 유적을 탐방할 수 있는 기회로도 많은 방문객들을 끌어들입니다.",
      },
      {
        no: 2,
        vi: "Bia Quốc Học",
        en: "Quoc Hoc Stele",
        ko: "꾸옥혹 비석은",
      },
      {
        no: 3,
        vi: "Bia Quốc Học tọa lạc giữa một ngoại cảnh thiên nhiên thơ mộng, nhất là phía sau có dòng sông Hương trong xanh êm ả, giữa một không gian kiến trúc độc đáo.",
        en: "Quoc Hoc Stele is located in a poetic natural setting, especially with the tranquil and clear Hương River flowing behind it, surrounded by a unique architectural space.",
        ko: "꾸옥혹 비석은 독특한 건축 공간으로 둘러싸인 시적인 자연 환경 속에 자리잡고 있으며, 특히 그 뒤로 맑고 고요한 향강이 흐르고 있어 더욱 아름다움을 더합니다.",
      },
    ],
  },
  {
    id: 18, // HotLineSection.jsx
    data: [
      {
        no: 0,
        vi: "Tư vấn chuyên nghiệp, tận tình",
        en: "Professional and dedicated consultation",
        ko: "전문적이고 헌신적인 상담",
      },
      {
        no: 1,
        vi: "Với đội ngũ nhân viên nhiều kinh nghiệm, am hiểu các điểm đến chúng tôi luôn sẵn sàng hỗ trợ và tư vấn mọi thông tin liên quan đến nhu cầu du lịch, tham quan của Quý khách!",
        en: "With an experienced team well-versed in heritage sites and destinations, we are always ready to assist and provide expert consultation on all information related to your travel and sightseeing needs!",
        ko: "경험이 풍부하고 유적지 및 관광지에 잘 알고 있는 팀과 함께, 우리는 귀하의 여행과 관광 요구 사항에 관련된 모든 정보를 지원하고 전문가 상담을 제공할 준비가 되어 있습니다!",
      },
    ],
  },
  {
    id: 19, // FooterSection.jsx
    data: [
      {
        no: 0,
        vi: "Liên kết với chúng tôi",
        en: "Connect with us",
        ko: "저희와 연결하기",
      },
      {
        no: 1,
        vi: "Liên kết",
        en: "Link",
        ko: "링크",
      },
      {
        no: 2,
        vi: "Khám phá Huế",
        en: "Hue Discovery",
        ko: "후에 발견",
      },
      {
        no: 3,
        vi: "Visit Huế",
        en: "Visit Hue",
        ko: "후에 방문",
      },
      {
        no: 4,
        vi: "Cổng TTBTDT Cố đô Huế",
        en: "Hue Monuments Conservation Centre",
        ko: "후에 유적지 보존 센터",
      },
      {
        no: 5,
        vi: "Điều khoản sử dụng",
        en: "Terms",
        ko: "이용 약관",
      },
      {
        no: 6,
        vi: "Điều khoản chung",
        en: "General Terms",
        ko: "일반 약관",
      },
      {
        no: 7,
        vi: "Thông tin",
        en: "Information",
        ko: "정보",
      },
      {
        no: 8,
        vi: "Chương trình khuyến mãi",
        en: "Promotional Programs",
        ko: "프로모션 프로그램",
      },
      {
        no: 9,
        vi: "Thời gian/Nội quy tham quan",
        en: "Visiting Time/Regulations",
        ko: "방문 시간/규정",
      },
      {
        no: 10,
        vi: "Bản quyền Website thuộc về Trung tâm Bảo tồn Di tích Cố đô Huế",
        en: "Website copyright belongs to Hue Monuments Conservation Centre",
        ko: "웹사이트 저작권은 후에 유적지 보존 센터에 속합니다",
      },
      {
        no: 11,
        vi: "Địa chỉ: Tam Toà, 33 Tống Duy Tân - thành phố Huế, Việt Nam",
        en: "Address: Tam Toa, 33 Tong Duy Tan, Hue City, Vietnam",
        ko: "주소: Tam Toa, 33 Tong Duy Tan, Hue City, Vietnam",
      },
      {
        no: 12,
        vi: "Email: huedisan@gmail.com",
        en: "Email: huedisan@gmail.com",
        ko: "이메일: huedisan@gmail.com",
      },
      {
        no: 13,
        vi: "Thiết kế và xây dựng:",
        en: "Designed by:",
        ko: "디자인 및 구축:",
      },
      {
        no: 14,
        vi: "HueCIT",
        en: "HueCIT",
        ko: "HueCIT",
      },
      {
        no: 15,
        vi: "",
        en: "",
        ko: "",
      },
    ],
  },
  {
    id: 20, // DieuKhoanPageNew.jsx, DieuKhoanChung.jsx
    data: [
      {
        no: 0,
        vi: "Điều khoản chung",
        en: "General Terms",
        ko: "일반 약관",
      },
      {
        no: 1,
        vi: "Điều khoản giao dịch",
        en: "Transaction Terms",
        ko: "거래 약관",
      },
      {
        no: 2,
        vi: "Chính sách bảo mật",
        en: "Privacy Policy",
        ko: "개인정보 보호정책",
      },
      {
        no: 3,
        vi: "",
        en: "",
        ko: "",
      },
      {
        no: 4,
        vi: "",
        en: "",
        ko: "",
      },
    ],
  },
  {
    id: 21, // DieuKhoanChung.jsx
    data: [
      {
        no: 0,
        vi: "Điều khoản chung",
        en: "General Terms",
        ko: "일반 조건",
      },
      {
        no: 1,
        vi: "1. Trách nhiệm của người sử dụng",
        en: "1. User Responsibility",
        ko: "1. 사용자 책임",
      },
      {
        no: 2,
        vi: "Khi truy cập vào trang web này, bạn đồng ý chấp nhận mọi rủi ro. Trung tâm Bảo tồn Di tích Cố đô Huế (sau đây gọi tắt là “Trung tâm BTDTCĐ” hoặc “Chúng tôi”) và các bên đối tác khác không chịu trách nhiệm về bất kỳ tổn thất nào do những hậu quả trực tiếp, tình cờ hay gián tiếp; những thất thoát, chi phí (bao gồm chi phí pháp lý, chi phí tư vấn hoặc các khoản chi tiêu khác) có thể phát sinh trực tiếp hoặc gián tiếp do việc truy cập trang web hoặc khi tải dữ liệu về máy; những tổn hại gặp phải do virus, hành động phá hoại trực tiếp hay gián tiếp của hệ thống máy tính khác, đường dây điện thoại, phần cứng, phần mềm, lỗi chương trình, hoặc bất kì các lỗi nào khác; đường truyền dẫn của máy tính hoặc nối kết mạng bị chậm…",
        en: "By accessing this website, you agree to accept all risks. The Hue Monuments Conservation Center (hereinafter referred to as “BTDTCĐ Center” or “We”) and other partners are not responsible for any losses resulting from direct, incidental, or indirect consequences; any losses, costs (including legal fees, consultation costs, or other expenses) that may arise directly or indirectly from accessing the website or downloading data to your device; damages caused by viruses, malicious actions directly or indirectly from other computer systems, phone lines, hardware, software, program errors, or any other faults; slow computer connections or network connections...",
        ko: "이 웹사이트에 접속함으로써 귀하는 모든 위험을 감수하는 데 동의합니다. 후에 유적 보존 센터(이하 'BTDTCĐ 센터' 또는 '저희')와 다른 파트너들은 웹사이트 접속이나 데이터를 다운로드하면서 발생할 수 있는 직접적, 우발적, 간접적인 결과로 인한 손실, 비용(법적 비용, 상담 비용 등) 등에 대해 책임지지 않습니다. 또한 바이러스나 다른 컴퓨터 시스템, 전화선, 하드웨어, 소프트웨어의 악성 행위, 프로그램 오류 및 기타 결함으로 인한 피해나 컴퓨터 연결이 느리거나 네트워크 연결 문제가 발생할 수 있습니다.",
      },
      {
        no: 3,
        vi: "2. Về nội dung trên trang web",
        en: "2. Website Content",
        ko: "2. 웹사이트 콘텐츠",
      },
      {
        no: 4,
        vi: "Tất cả những thông tin ở đây được cung cấp cho bạn một cách trung thực như bản thân sự việc. Trung tâm BTDTCĐ và các bên liên quan không bảo đảm, hay có bất kỳ tuyên bố nào liên quan đến tính chính xác, tin cậy của việc sử dụng hay kết quả của việc sử dụng nội dung trên trang web này. Nội dung trên website được cung cấp vì lợi ích của cộng đồng và có tính phi thương mại. Các cá nhân và tổ chức không được phép sử dụng nội dung trên website này với mục đích thương mại mà không có sự ưng thuận của Trung tâm BTDTCĐ bằng văn bản. Mặc dù Trung tâm BTDTCĐ luôn cố gắng cập nhật thường xuyên các nội dung tại trang web, nhưng chúng tôi không bảo đảm rằng các thông tin đó là mới nhất, chính xác hay đầy đủ. Tất cả các nội dung website có thể được thay đổi bất kỳ lúc nào.",
        en: "All information here is provided to you in good faith as it is. HMCC Center and related parties do not guarantee or make any statements regarding the accuracy, reliability, or results of using the content on this website. The content on the website is provided for public benefit and is non-commercial. Individuals and organizations are not allowed to use the content on this website for commercial purposes without the written consent of HMCC Center. Although HMCC Center strives to regularly update the website content, we do not guarantee that the information is the most up-to-date, accurate, or complete. All website content may change at any time.",
        ko: "이곳에 있는 모든 정보는 그 자체로 신뢰를 바탕으로 제공됩니다. HMCC 센터와 관련된 당사자들은 이 웹사이트의 내용을 사용하는 정확성, 신뢰성 또는 그 결과에 대해 보증하지 않으며 어떠한 진술도 하지 않습니다. 웹사이트의 콘텐츠는 공익을 위해 제공되며 상업적이지 않습니다. 개인이나 조직은 HMCC 센터의 서면 동의 없이 웹사이트 콘텐츠를 상업적 목적으로 사용할 수 없습니다. HMCC 센터는 웹사이트 콘텐츠를 정기적으로 업데이트하려고 노력하지만, 정보가 최신이며 정확하고 완전하다는 보장은 하지 않습니다. 모든 웹사이트 콘텐츠는 언제든지 변경될 수 있습니다.",
      },
      {
        no: 5,
        vi: "3. Về bản quyền",
        en: "3. Copyright",
        ko: "3. 저작권",
      },
      {
        no: 6,
        vi: "Trung tâm BTDTCĐ là chủ bản quyền của trang web này. Việc chỉnh sửa trang, nội dung, và sắp xếp thuộc về thẩm quyền của Trung tâm BTDTCĐ. Sự chỉnh sửa, thay đổi, phân phối hoặc tái sử dụng những nội dung trong trang này vì bất kì mục đích nào khác được xem như vi phạm quyền lợi hợp pháp của Trung tâm BTDTCĐ.",
        en: "HMCC Center holds the copyright of this website. Editing the page, content, and layout is under the authority of HMCC Center. Editing, modifying, distributing, or reusing the content on this page for any other purposes is considered a violation of HMCC Center's legal rights.",
        ko: "HMCC 센터는 이 웹사이트의 저작권을 보유합니다. 페이지, 콘텐츠 및 레이아웃의 편집은 HMCC 센터의 권한에 속합니다. 이 페이지의 콘텐츠를 편집, 수정, 배포하거나 다른 목적으로 재사용하는 것은 HMCC 센터의 법적 권리를 침해하는 것으로 간주됩니다.",
      },
      {
        no: 7,
        vi: "4. Về việc sử dụng thông tin",
        en: "4. Use of Information",
        ko: "4. 정보 사용",
      },
      {
        no: 8,
        vi: "Chúng tôi sẽ không sử dụng thông tin cá nhân của bạn trên website này nếu không được phép. Nếu bạn đồng ý cung cấp thông tin cá nhân, bạn sẽ được bảo vệ. Thông tin của bạn sẽ được sử dụng với mục đích, liên lạc với bạn để thông báo các thông tin cập nhật của Trung tâm BTDTCĐ như chương trình, sự kiện, khuyến mại qua email hoặc bưu điện. Thông tin cá nhân của bạn sẽ không được gửi cho bất kỳ ai sử dụng ngoài trang web Trung tâm BTDTCĐ, ngoại trừ những mở rộng cần thiết để bạn có thể tham gia vào trang web (những nhà cung cấp dịch vụ, đối tác, các công ty quảng cáo) và yêu cầu cung cấp bởi luật pháp. Nếu chúng tôi chia sẻ thông tin cá nhân của bạn cho các nhà cung cấp dịch vụ, công ty quảng cáo, các công ty đối tác liên quan, thì chúng tôi cũng yêu cầu họ bảo vệ thông tin cá nhân của bạn như cách chúng tôi thực hiện.",
        en: "We will not use your personal information on this website without permission. If you agree to provide personal information, it will be protected. Your information will be used to contact you with updates from HMCC Center, such as programs, events, and promotions via email or postal mail. Your personal information will not be shared with anyone outside HMCC Center website, except for necessary extensions to allow you to participate in the website (such as service providers, partners, advertising companies) or as required by law. If we share your personal information with service providers, advertising companies, or related partners, we will require them to protect your information as we do.",
        ko: "우리는 귀하의 허락 없이 이 웹사이트에서 귀하의 개인 정보를 사용하지 않습니다. 귀하가 개인 정보를 제공하는 데 동의하면 귀하는 보호됩니다. 귀하의 정보는 HMCC 센터에서 보내는 업데이트, 프로그램, 이벤트 및 홍보 내용을 이메일 또는 우편으로 연락하는 데 사용됩니다. 귀하의 개인 정보는 HMCC 센터 웹사이트 외의 다른 사람에게 공유되지 않으며, 웹사이트에 참여할 수 있도록 필요한 서비스 제공자, 파트너, 광고 회사 등과 법률에 따라 요구되는 경우를 제외하고는 공유되지 않습니다. 우리가 귀하의 개인 정보를 서비스 제공자, 광고 회사 또는 관련 파트너와 공유하는 경우, 그들도 우리와 같은 방식으로 귀하의 정보를 보호하도록 요구할 것입니다.",
      },
      {
        no: 9,
        vi: "5. Vể việc tải dữ liệu",
        en: "5. Data Download",
        ko: "5. 데이터 다운로드",
      },
      {
        no: 10,
        vi: "Nếu bạn tải về máy những dữ liệu từ trang này, thì các dữ liệu tải về sẽ thuộc bản quyền của Trung tâm BTDTCĐ và cho phép bạn sử dụng. Bạn không được sở hữu những dữ liệu đã tải và Trung tâm BTDTCĐ không nhượng quyền cho bạn. Bạn cũng không được phép bán, phân phối lại, tuyên bố quyền sở hữu…",
        en: "If you download data from this site, the downloaded data is copyrighted by HMCC Center and is for your use. You do not own the downloaded data, and HMCC Center does not grant you any rights. You are also not allowed to sell, redistribute, claim ownership...",
        ko: "이 사이트에서 데이터를 다운로드하면 다운로드된 데이터는 HMCC 센터의 저작권이 있으며 귀하의 사용을 위해 제공됩니다. 귀하는 다운로드된 데이터를 소유하지 않으며, HMCC 센터는 귀하에게 어떠한 권한도 부여하지 않습니다. 또한 판매, 재배포, 소유권 주장 등을 허용하지 않습니다.",
      },
      {
        no: 11,
        vi: "6. Thay đổi nội dung",
        en: "6. Content Changes",
        ko: "6. 콘텐츠 변경",
      },
      {
        no: 12,
        vi: "Trung tâm BTDTCĐ giữ quyền thay đổi, chỉnh sửa và loại bỏ những thông tin hợp pháp vào bất kỳ thời điểm nào vì bất kỳ lý do nào.",
        en: "HMCC Center reserves the right to change, modify, and remove any legal content at any time for any reason.",
        ko: "HMCC 센터는 어떤 이유로든 언제든지 법적 콘텐츠를 변경, 수정 및 삭제할 권리를 보유합니다.",
      },
      {
        no: 13,
        vi: "7. Liên kết với các trang khác",
        en: "7. Links to Other Websites",
        ko: "7. 다른 웹사이트 링크",
      },
      {
        no: 14,
        vi: "Mặc dù trang web này có thể được liên kết với những trang khác, Trung tâm BTDTCĐ không trực tiếp hoặc gián tiếp tán thành, tổ chức, tài trợ, đứng sau hoặc sát nhập với những trang đó, trừ phi điều này được nêu ra rõ ràng. Khi truy cập vào trang web, bạn phải hiểu và chấp nhận rằng Trung tâm BTDTCĐ không thể kiểm soát tất cả những trang liên kết với trang Trung tâm BTDTCĐ và cũng không chịu trách nhiệm cho nội dung của những trang liên kết.",
        en: "Although this website may link to other websites, HMCC Center does not directly or indirectly endorse, organize, fund, support, or affiliate with these sites unless explicitly stated. When accessing these websites, you must understand and accept that HMCC Center cannot control all the websites linked to HMCC Center’s website and is not responsible for the content of those linked sites.",
        ko: "이 웹사이트는 다른 웹사이트와 연결될 수 있지만, HMCC 센터는 명시적으로 언급되지 않는 한 이러한 사이트를 직접적으로 또는 간접적으로 승인, 조직, 자금 지원, 지원 또는 제휴하지 않습니다. 웹사이트에 접속할 때 귀하는 HMCC 센터가 모든 연결된 웹사이트를 통제할 수 없으며, 이러한 링크된 웹사이트의 내용에 대해 책임을 지지 않음을 이해하고 동의해야 합니다.",
      },
      {
        no: 15,
        vi: "8. Đưa thông tin lên trang web",
        en: "8. Posting Information on the Website",
        ko: "8. 웹사이트에 정보 게시",
      },
      {
        no: 16,
        vi: "Bạn không được đưa lên, hoặc chuyển tải lên trang web tất cả những hình ảnh, từ ngữ khiêu dâm, thô tục, xúc phạm, phỉ báng, bôi nhọ, đe dọa, những thông tin không hợp pháp hoặc những thông tin có thể đưa đến việc vi phạm pháp luật, trách nhiệm pháp lý. Trung tâm BTDTCĐ và tất cả các bên có liên quan đến việc xây dựng và quản lý trang web không chịu trách nhiệm hoặc có nghĩa vụ pháp lý đối với những phát sinh từ nội dung do bạn tải lên trang web.",
        en: "You are not allowed to upload or transmit any obscene, offensive, defamatory, slanderous, threatening, illegal information, or content that may lead to legal violations, liabilities, or any harm. HMCC Center and all parties involved in building and managing the website are not responsible or legally liable for any consequences arising from content you upload to the website.",
        ko: "귀하는 음란하거나, 불쾌감을 주거나, 명예훼손적이거나, 비방적이거나, 위협적이거나, 불법적인 정보를 웹사이트에 업로드하거나 전송할 수 없습니다. HMCC 센터와 웹사이트 구축 및 관리와 관련된 모든 당사자는 귀하가 웹사이트에 업로드한 콘텐츠에서 발생하는 결과에 대해 책임지지 않으며 법적 의무를 지지 않습니다.",
      },
      {
        no: 17,
        vi: "9. Luật áp dụng",
        en: "9. Applicable Law",
        ko: "9. 적용 법률",
      },
      {
        no: 18,
        vi: "Mọi hoạt động phát sinh từ trang web có thể sẽ được phân tích và đánh giá theo luật pháp Việt Nam và toà án tỉnh Thừa Thiên Huế. Và bạn phải đồng ý tuân theo các điều khoản riêng của các toà án này.",
        en: "All activities arising from this website will be governed and assessed according to the laws of Vietnam and the courts of Thua Thien Hue Province. You must agree to abide by the specific terms of these courts.",
        ko: "이 웹사이트에서 발생하는 모든 활동은 베트남 법률 및 후아 비엔 후에 지방 법원의 법에 따라 분석되고 평가될 수 있습니다. 귀하는 이 법원의 특정 조건을 준수해야 합니다.",
      },
    ],
  },
  {
    id: 22, // DieuKhoanGiaoDich.jsx
    data: [
      {
        no: 0,
        vi: "Điều khoản giao dịch",
        en: "Transaction Terms",
        ko: "거래 조건",
      },
      {
        no: 1,
        vi: `<h5 class="addcart-header ticket-header">
                        1. Phạm vi áp dụng
                    </h5>
                    <p>
                        Điều kiện dưới đây áp dụng riêng cho chức năng mua vé trực
                        tuyến tại Website để tham quan các điểm di tích Huế do Trung
                        tâm BTDTCĐ quản lý. Khi sử dụng chức năng để mua vé, Quý
                        khách mặc nhiên đã chấp thuận và tuân thủ tất cả các chỉ
                        dẫn, điều khoản, điều kiện và lưu ý đăng tải trên Website,
                        bao gồm nhưng không giới hạn bởi Điều kiện sử dụng nêu ở
                        đây. Nếu Quý khách không có ý định mua vé trực tuyến hay
                        không đồng ý với bất kỳ điều khoản hay điều kiện nào nêu
                        trong Điều kiện sử dụng, xin hãy dừng sử dụng chức năng này.
                    </p>
                    <h5 class="addcart-header ticket-header">
                        2. Điều kiện sử dụng tính năng mua vé trực Tuyến
                    </h5>
                    <p>
                        Quý khách phải nhập đầy đủ và đúng các thông tin chúng tôi
                        yêu cầu trong quá trình đặt mua vé. Chúng tôi không chịu bất
                        kỳ trách nhiệm nào, dù trực tiếp hay gián tiếp, đối với
                        những thiệt hại hoặc mất mát gây ra do quý khách không tuân
                        thủ quy định.
                    </p>
                    <h5 class="addcart-header ticket-header">
                        3. Quy định về đặt vé trực tuyến
                    </h5>
                    <p>
                        Tính năng đặt vé trực tuyến hiện áp dụng cho tất cả các
                        khách tham quan của Trung tâm BTDTCĐ
                    </p>
                    <p>
                        Khi tiến hành các bước thanh toán, cần đọc kĩ các thông tin
                        trên địa điểm tham quan, số lượng người và đối tượng tham
                        quan trước khi hoàn tất việc xác nhận tất cả các thông tin
                        về vé.
                    </p>
                    <p>
                        Quý khách thanh toán giao dịch đặt vé theo quy định tại
                        Chính Sách Thanh Toán đăng tải trên Trung tâm BTDTCĐ trước
                        khi nhận mã đặt vé của giao dịch đó. Khi quý khách nhấn
                        (click) vào ô “Thanh toán” để tiến hành thanh toán Đặt chỗ
                        có nghĩa là đã xác nhận rà soát thông tin Đặt chỗ; và đồng ý
                        là Điều Khoản Và Điều Kiện sẽ được áp dụng cho giao dịch mua
                        vé trong giao dịch đó
                    </p>
                    <p>
                        Email xác nhận đặt vé sau khi hoàn thành việc thanh toán vé
                        trực tuyến, quý khách sẽ nhận được thư xác nhận thông tin
                        chi tiết vé đã thanh toán thông qua địa chỉ thư điện tử
                        (email) mà quý khách đã cung cấp. Email xác nhận thông tin
                        đặt vé có thể đi vào hộp thư rác (spam mail) của bạn, vì vậy
                        hãy kiểm tra chúng trước khi liên lạc với Trung tâm BTDTCĐ
                    </p>
                    <p>
                        Trong suốt quá trình đăng ký, quý khách đồng ý nhận email
                        quảng cáo từ website. Sau đó, nếu không muốn tiếp tục nhận
                        mail, quý khách có thể từ chối bằng cách nhấp vào đường link
                        ở dưới cùng trong mọi email quảng cáo
                    </p>

                    <h5 class="addcart-header ticket-header">4. Giá vé</h5>
                    <p>
                        Giá vé được niêm yết tại website là giá bán cuối cùng đã bao
                        gồm thuế Giá trị gia tăng (VAT). Giá vé có thể thay đổi tùy
                        thời điểm và chương trình khuyến mãi kèm theo và sẽ được
                        hiển thị rõ tại trang Đặt vé khi quý khách tiến hành đặt
                        hàng.
                    </p>
                    <p>
                        Giá vé khi đặt vé trực tuyến trên website Trung tâm BTDTCĐ
                        là giá vé người lớn và trẻ em. Các loại vé cho các đối tượng
                        khác vui lòng mua trực tiếp tại quầy vé tại các điểm tham
                        quan.
                    </p>
                    <p>
                        Khán giả khi đến tham quan vui lòng mang theo giấy tờ tùy
                        thân hoặc hình ảnh của giấy tờ tùy thân có ảnh nhận diện và
                        ngày tháng năm sinh để đảm bảo việc tuân thủ theo quy định.
                    </p>

                    <h5 class="addcart-header ticket-header">
                        5. Giá trị giao dịch và hình thức thanh toán
                    </h5>
                    <p>
                        Trung tâm BTDTCĐ cung cấp các hình thức thanh toán: thẻ
                        Thanh toán Nội địa, một số loại ví điện tử hoặc thanh toán
                        tại quầy vé
                    </p>
                    <p>
                        Trừ một số trường hợp có ghi chú riêng, thông thường quý
                        khách có thể lựa chọn một trong các hình thức thanh toán
                        trên khi tiến hành đặt vé.
                    </p>
                    <p>Để đảm bảo an toàn thanh toán, Khách hàng lưu ý</p>
                    <p class='p-subcontent'>
                        <strong>1.</strong> Chỉ thực hiện thanh toán trực tuyến tại
                        cửa sổ liên kết từ website Trung tâm BTDTCĐ chuyển đến
                    </p>
                    <p class='p-subcontent'>
                        <strong>2.</strong> Sử dụng và bảo quản thẻ (thẻ tín dụng,
                        thẻ ATM, thẻ mua hàng…) và thông tin tài khoản/thông tin thẻ
                        cẩn thận;
                    </p>
                    <p class='p-subcontent'>
                        <strong>3.</strong> Ngay khi phát hiện giao dịch phát sinh
                        bất thường nào tại website Trung tâm BTDTCĐ, Khách hàng cần
                        liên hệ ngay với bộ phận chăm sóc Khách hàng của Trung tâm
                        BTDTCĐ để được xử lý kịp thời
                    </p>
                    <p class='p-subcontent'>
                        <strong>4.</strong> Kiểm tra tài khoản ngân hàng của mình
                        thường xuyên để đảm bảo tất cả giao dịch qua thẻ đều nằm
                        trong tầm kiểm soát.
                    </p>

                    <h5 class="addcart-header ticket-header">
                        6. Giao kết giao dịch tại Trung tâm Bảo tồn di tích Cố đô
                        Huế
                    </h5>
                    <p>
                        Khách hàng khi mua vé trực tuyến tại website Trung tâm
                        BTDTCĐ phải thực hiện các thao tác theo trình tự sau:
                    </p>
                    <p class='p-subcontent'>
                        <strong>Bước 1:</strong> Khách hàng lựa chọn địa điểm tham
                        quan.
                    </p>
                    <p class='p-subcontent'>
                        <strong>Bước 2:</strong> Khách hàng lựa chọn số lượng người
                        tham quan.
                    </p>
                    <p class='p-subcontent'>
                        <strong>Bước 3:</strong> Thanh toán bằng các hình thức thanh
                        toán online qua tài khoản ngân hàng.
                    </p>
                    <p class='p-subcontent'>
                        <strong>Bước 4:</strong> Khách hàng nhận mã đặt chỗ sau khi
                        thanh toán hoặc qua email.
                    </p>
                    <p class='p-subcontent'>
                        <strong>Bước 5:</strong> Khách hàng cung cấp mã đặt vé và
                        các thông tin cá nhân dùng đặt vé để vào Cổng tham quan. Nếu
                        khách hàng không cung cấp được thông tin cá nhân và mã đặt
                        vé, Trung tâm Bảo tồn di tích Cố đô Huế có quyền từ chối
                        tham quan.
                    </p>

                    <h5 class="addcart-header ticket-header">
                        7. Thay đổi, hủy bỏ giao dịch đặt vé tại Trung tâm Bảo tồn
                        di tích Cố đô Huế
                    </h5>
                    <p>
                        Hiện tại Trung tâm BTDTCĐ chưa hỗ trợ dịch vụ hủy hoặc thay
                        đổi thông tin vé đã thanh toán thành công trên website
                    </p>
                    <p>
                        Hệ thống Đặt vé Online của Trung tâm BTDTCĐ có liên kết với
                        rất nhiều đối tác khác, bao gồm Cổng thanh toán VNPay, các
                        ngân hàng nội địa. Việc thanh toán thành công hay không phụ
                        thuộc rất nhiều vào kết nối mạng của quý khách, việc truyền
                        dẫn, nhận và trả tín hiệu của các tổ chức đối tác trên.
                        Trung tâm BTDTCĐ chỉ thực hiện hoàn tiền trong trường hợp
                        khi giao dịch, tài khoản của quý khách đã bị trừ tiền nhưng
                        hệ thống của chúng tôi không ghi nhận việc đặt vé đó, và quý
                        khách không nhận được xác nhận đặt vé thành công. Khi đó,
                        quý khách vui lòng liên hệ hotline 0234.3523237 (từ 8:00 đến
                        20:00 tất cả các ngày trong tuần) hoặc bạn có thể liên hệ
                        với chúng tôi qua địa chỉ email huedisan@gmail.com để được
                        hỗ trợ.
                    </p>
                    <p>
                        Sau khi đã xác nhận các thông tin của khách hàng cung cấp về
                        giao dịch không thành công, tùy theo từng loại tài khoản
                        khách hàng sử dụng mà việc hoàn tiền sẽ có thời gian khác
                        nhau:
                    </p>
                    <p class='p-subcontent'>
                        <strong>1.</strong> Thẻ ATM ( Nội địa): hoàn tiền trong
                        07-15 ngày (không tính cuối tuần và ngày lễ)
                    </p>
                    <p class='p-subcontent'>
                        <strong>2.</strong> Riêng các giao dịch thanh toán bằng tiền
                        trong ví điện tử: sẽ được hoàn trực tiếp vào số dư ví trong
                        vòng 05-10 ngày (không tính cuối tuần và ngày lễ). Còn các
                        trường hợp thanh toán bằng ví nhưng thông qua liên kết thẻ
                        sẽ tương tự 2 trường hợp thẻ nội địa và quốc tế như trên.
                    </p>
                    <p class='p-subcontent'>
                        <strong>3.</strong> Thời gian hoàn tiền không tính các ngày
                        thứ 7, Chủ nhật và lễ Tết
                    </p>
                    <p class='p-subcontent'>
                        <strong>4.</strong> Trước khi thanh toán vé trực tuyến,
                        chúng tôi khuyên quý khách nên xác nhận lại Địa điểm, Số
                        lượng người tham quan, đối tượng muốn tham quan.
                    </p>

                    <h5 class="addcart-header ticket-header">
                        8. Thương hiệu và bản quyền
                    </h5>
                    <p>
                        Mọi quyền sở hữu trí tuệ (đã đăng ký hoặc chưa đăng ký), nội
                        dung thông tin và tất cả các thiết kế, văn bản, đồ họa, phần
                        mềm, hình ảnh, video, âm nhạc, âm thanh, biên dịch phần mềm,
                        mã nguồn và phần mềm cơ bản đều là tài sản của Trung tâm
                        BTDTCĐ. Toàn bộ nội dung của trang web được bảo vệ theo pháp
                        luật sở hữu trí tuệ của Việt Nam và các công ước, điều ước
                        quốc tế mà Việt Nam tham gia hoặc là thành viên.
                    </p>

                    <h5 class="addcart-header ticket-header">
                        9. Luật áp dụng và giải quyết tranh chấp
                    </h5>
                    <p>
                        Các điều kiện, điều khoản và nội dung của trang web này được
                        điều chỉnh và giải thích theo luật pháp Việt Nam. Các tranh
                        chấp phát sinh từ hoặc liên quan đến (các) giao dịch thực
                        hiện tại trang web này sẽ được ưu tiên giải quyết thông qua
                        thương lượng, hòa giải. Trường hợp các bên không tự giải
                        quyết, tranh chấp sẽ được đưa ra xét xử tại Tòa án cấp có
                        thẩm quyền của Việt Nam.
                    </p>

                    <h5 class="addcart-header ticket-header">
                        10. Quy định về bảo mật
                    </h5>
                    <p>
                        Trang web của chúng tôi coi trọng việc bảo mật thông tin và
                        sử dụng các biện pháp tốt nhất bảo vệ thông tin và việc
                        thanh toán của quý khách. Thông tin của quý khách trong quá
                        trình thanh toán sẽ được mã hóa để đảm bảo an toàn. Sau khi
                        quý khách hoàn thành quá trình đặt hàng, quý khách sẽ thoát
                        khỏi chế độ an toàn.
                    </p>
                    <p>
                        Quý khách không được sử dụng bất kỳ chương trình, công cụ
                        hay hình thức nào khác để can thiệp vào hệ thống hay làm
                        thay đổi cấu trúc dữ liệu. Trang web cũng nghiêm cấm việc
                        phát tán, truyền bá hay cổ vũ cho bất kỳ hoạt động nào nhằm
                        can thiệp, phá hoại hay xâm nhập vào dữ liệu của hệ thống.
                        Cá nhân hay tổ chức vi phạm sẽ bị tước bỏ mọi quyền lợi cũng
                        như sẽ bị truy tố trước pháp luật nếu cần thiết. Mọi thông
                        tin giao dịch sẽ được bảo mật trừ trường hợp buộc phải cung
                        cấp theo yêu cầu của tòa án, (các) cơ quan có thẩm quyền
                        hoặc theo quy định của pháp luật.
                    </p>

                    <h5 class="addcart-header ticket-header">
                        11. Giải quyết hậu quả do lỗi nhập sai thông tin thương mại
                        tại Trung tâm Bảo tồn di tích Cố đô Huế
                    </h5>
                    <p>
                        Khách hàng có trách nhiệm cung cấp thông tin đầy đủ và chính
                        xác khi tham gia giao dịch tại Trung tâm Bảo tồn di tích Cố
                        đô Huế. Trong trường hợp khách hàng nhập sai thông tin tại
                        đặt vé, Trung tâm Bảo tồn di tích Cố đô Huế có quyền từ chối
                        thực hiện giao dịch. Ngoài ra, trong mọi trường hợp, khách
                        hàng đều có quyền đơn phương chấm dứt giao dịch nếu đã thực
                        hiện bằng cách thông báo cho Trung tâm Bảo tồn di tích Cố đô
                        Huế qua đường dây nóng 0234.3523237.
                    </p>

                    <h5 class="addcart-header ticket-header">
                        12. Quy định chấm dứt thỏa thuận
                    </h5>
                    <p>
                        Trong trường hợp có bất kỳ thiệt hại nào phát sinh do việc
                        vi phạm Quy Định sử dụng trang web, chúng tôi có quyền đình
                        chỉ hoặc khóa tài khoản của quý khách vĩnh viễn. Nếu quý
                        khách không hài lòng với trang web hoặc bất kỳ điều khoản,
                        điều kiện, quy tắc, chính sách, hướng dẫn, hoặc cách thức
                        vận hành của Trung tâm Bảo tồn di tích Cố đô Huế thì biện
                        pháp khắc phục duy nhất là ngưng sử dụng dịch vụ của chúng
                        tôi.
                    </p>
                    <p>
                        Xin quý khách lưu ý chỉ mua hàng khi chấp nhận và hiểu rõ
                        những quy định trên. Nếu cần hỗ trợ thêm thông tin, quý
                        khách vui lòng tham khảo tại eticket.hueworldheritage.org.vn
                    </p>`,
        en: `<h5 class="addcart-header ticket-header">
                        1. Scope of Application
                    </h5>
                    <p>
                        The following terms apply exclusively to the online ticket booking function on the website for visiting Hue heritage sites managed by HMCC Center. By using this function to purchase tickets, you implicitly agree to comply with all instructions, terms, conditions, and notices posted on the website, including but not limited to the Terms of Use outlined here. If you do not intend to buy tickets online or disagree with any of the terms or conditions listed in the Terms of Use, please stop using this function.
                    </p>
                    <h5 class="addcart-header ticket-header">
                        2. Conditions for Using the Online Ticket Booking Feature
                    </h5>
                    <p>
                        You must enter all required and correct information during the booking process. We are not responsible for any direct or indirect damages or losses caused by your failure to comply with the regulations.
                    </p>
                    <h5 class="addcart-header ticket-header">
                        3. Online Ticket Booking Regulations
                    </h5>
                    <p>
                        The online ticket booking feature is currently available for all visitors to HMCC Center.
                    </p>
                    <p>
                        When proceeding with payment steps, carefully read the information about the visiting site, number of people, and types of visitors before completing the confirmation of all ticket information.
                    </p>
                    <p>
                        You must pay for the ticket booking transaction as per the Payment Policy posted on HMCC Center website before receiving the booking code for that transaction. When you click on the "Pay" button to proceed with payment for the booking, it means you have confirmed the booking details and agree to the Terms and Conditions being applied to this ticket purchase transaction.
                    </p>
                    <p>
                        After completing the online payment, you will receive a confirmation email with detailed ticket information through the email address you provided. The confirmation email may go into your spam folder, so please check it before contacting HMCC Center.
                    </p>
                    <p>
                        During the registration process, you agree to receive promotional emails from the website. If you no longer wish to receive such emails, you can opt-out by clicking the unsubscribe link at the bottom of any promotional email.
                    </p>

                    <h5 class="addcart-header ticket-header">4. Ticket Price</h5>
                    <p>
                        The ticket price listed on the website is the final sale price, including VAT. The ticket price may change depending on the time and promotional programs, and it will be clearly displayed on the Ticket Booking page when you place the order.
                    </p>
                    <p>
                        The ticket price for online bookings on HMCC Center website is for both adults and children. Tickets for other types of visitors should be purchased directly at the ticket counters at the visit sites.
                    </p>
                    <p>
                        Visitors should bring identification or a photo of identification with a recognizable photo and date of birth to ensure compliance with the regulations.
                    </p>

                    <h5 class="addcart-header ticket-header">
                        5. Transaction Value and Payment Methods
                    </h5>
                    <p>
                        HMCC Center provides several payment methods: domestic payment cards, some e-wallets, or payment at the ticket counter.
                    </p>
                    <p>
                        Unless otherwise noted, you can typically choose one of the above payment methods when placing an order.
                    </p>
                    <p>To ensure payment security, customers should note the following:</p>
                    <p class='p-subcontent'>
                        <strong>1.</strong> Only perform online payments via the link window from HMCC Center website.
                    </p>
                    <p class='p-subcontent'>
                        <strong>2.</strong> Use and store your card (credit card, ATM card, shopping card, etc.) and account/card information carefully.
                    </p>
                    <p class='p-subcontent'>
                        <strong>3.</strong> If you detect any unusual transactions on HMCC Center website, contact the customer service department immediately for timely assistance.
                    </p>
                    <p class='p-subcontent'>
                        <strong>4.</strong> Regularly check your bank account to ensure all transactions via your card are under control.
                    </p>

                    <h5 class="addcart-header ticket-header">
                        6. Conclusion of Transactions at the Hue Monuments Conservation Center
                    </h5>
                    <p>
                        When purchasing tickets online on HMCC Center website, customers must perform the following steps:
                    </p>
                    <p class='p-subcontent'>
                        <strong>Step 1:</strong> Select the visiting site.
                    </p>
                    <p class='p-subcontent'>
                        <strong>Step 2:</strong> Choose the number of visitors.
                    </p>
                    <p class='p-subcontent'>
                        <strong>Step 3:</strong> Make the payment via online bank account.
                    </p>
                    <p class='p-subcontent'>
                        <strong>Step 4:</strong> Receive the booking code after payment or via email.
                    </p>
                    <p class='p-subcontent'>
                        <strong>Step 5:</strong> Provide the booking code and personal information used for booking to enter the Visiting Gate. If you fail to provide personal information and the booking code, the Hue Monuments Conservation Center reserves the right to deny entry.
                    </p>

                    <h5 class="addcart-header ticket-header">
                        7. Change or Cancel a Booking Transaction at the Hue Monuments Conservation Center
                    </h5>
                    <p>
                        Currently, HMCC Center does not support the service of changing or canceling successfully paid tickets on the website.
                    </p>
                    <p>
                        The Online Ticket Booking System of HMCC Center is linked with many other partners, including VNPay payment gateway and local banks. Whether a transaction is successful or not depends on your network connection and the transmission, reception, and return of signals from these partner organizations. HMCC Center will only refund if the transaction is successful, but the booking is not recorded in our system, and you do not receive a successful booking confirmation. In that case, please contact the hotline 0234.3523237 (from 8:00 to 20:00 daily) or email huedisan@gmail.com for support.
                    </p>
                    <p>
                        After confirming the customer's transaction information, refund times may vary depending on the type of account used:
                    </p>
                    <p class='p-subcontent'>
                        <strong>1.</strong> ATM card (Domestic): refund within 07-15 days (excluding weekends and holidays).
                    </p>
                    <p class='p-subcontent'>
                        <strong>2.</strong> For transactions paid via e-wallet, the refund will be directly credited to the wallet balance within 05-10 days (excluding weekends and holidays). Other cases using wallet payments through linked cards will follow the refund process similar to the domestic and international card types above.
                    </p>
                    <p class='p-subcontent'>
                        <strong>3.</strong> Refund times do not include Saturdays, Sundays, and public holidays.
                    </p>
                    <p class='p-subcontent'>
                        <strong>4.</strong> Before completing online payment, we recommend customers verify the Site, Number of visitors, and the type of visitors.
                    </p>

                    <h5 class="addcart-header ticket-header">
                        8. Trademark and Copyright
                    </h5>
                    <p>
                        All intellectual property rights (registered or unregistered), content information, and all designs, text, graphics, software, images, videos, music, sounds, software compilation, source code, and software are the property of HMCC Center. All content on the website is protected under Vietnamese intellectual property laws and international conventions or treaties to which Vietnam is a party or member.
                    </p>

                    <h5 class="addcart-header ticket-header">
                        9. Applicable Law and Dispute Resolution
                    </h5>
                    <p>
                        The terms, conditions, and content of this website are governed and interpreted in accordance with the laws of Vietnam. Disputes arising from or related to transactions on this website will be resolved primarily through negotiation and reconciliation. If the parties cannot resolve the dispute, it will be brought to the competent courts in Vietnam.
                    </p>

                    <h5 class="addcart-header ticket-header">
                        10. Privacy Policy
                    </h5>
                    <p>
                        Our website values information security and uses the best measures to protect your information and payment. Your information during the payment process will be encrypted for safety. After completing the booking process, you will exit the secure mode.
                    </p>
                    <p>
                        You are not allowed to use any programs, tools, or other methods to interfere with the system or alter the data structure. The website also prohibits the dissemination, promotion, or encouragement of any activity that aims to interfere with, destroy, or invade system data. Any individual or organization violating these rules will lose all privileges and may be prosecuted under the law if necessary. All transaction information will be kept confidential unless required to be disclosed by court order, competent authorities, or as per the law.
                    </p>

                    <h5 class="addcart-header ticket-header">
                        11. Resolving Consequences of Incorrect Commercial Information Entry at the Hue Monuments Conservation Center
                    </h5>
                    <p>
                        Customers are responsible for providing complete and accurate information when transacting at the Hue Monuments Conservation Center. In case a customer enters incorrect information during ticket booking, the Hue Monuments Conservation Center reserves the right to refuse to process the transaction. Additionally, customers have the right to unilaterally terminate the transaction by notifying the Hue Monuments Conservation Center via the hotline 0234.3523237.
                    </p>

                    <h5 class="addcart-header ticket-header">
                        12. Termination of Agreement Regulations
                    </h5>
                    <p>
                        In case of any damage caused by violation of the Terms of Use on the website, we have the right to suspend or permanently block your account. If you are not satisfied with the website or any of its terms, conditions, rules, policies, guidelines, or operational methods, the only remedy is to cease using our services.
                    </p>
                    <p>
                        Please note to only purchase when you accept and fully understand the regulations above. If you need further assistance, please refer to eticket.hueworldheritage.org.vn
                    </p>`,
        ko: `<h5 class="addcart-header ticket-header"> 1. 적용 범위 </h5> 
                <p> 아래 조건은 웹사이트를 통한 온라인 티켓 구매 기능에만 적용됩니다. 이 기능은 후에 호이 센터에서 관리하는 유적지를 방문하는 티켓을 구매하는 데 사용됩니다. 고객님이 이 기능을 통해 티켓을 구매할 때, 고객님은 본 웹사이트에 게시된 모든 지침, 조건, 조항 및 안내 사항에 동의하고 이를 준수하는 것으로 간주됩니다. 온라인 티켓을 구매할 의향이 없거나 이 이용 약관에 동의하지 않으면 이 기능을 사용하지 말아 주십시오. </p> 
                <h5 class="addcart-header ticket-header"> 2. 온라인 티켓 구매 기능의 이용 조건 </h5> 
                <p> 고객님은 티켓 구매 과정에서 요구하는 모든 정보를 정확히 입력해야 합니다. 규정을 준수하지 않은 경우 발생할 수 있는 손해나 손실에 대해서는 당사가 책임지지 않습니다. </p> <h5 class="addcart-header ticket-header"> 3. 온라인 티켓 예약 규정 </h5> 
                <p> 현재 온라인 티켓 예약 기능은 후에 문화유산 보존 센터를 방문하는 모든 관람객에게 적용됩니다. </p> 
                <p> 결제 진행 시, 관람 장소, 인원 수 및 관람객 유형에 대한 정보를 충분히 확인한 후 예약 정보를 최종 확인해 주세요. </p> 
                <p> 고객님은 후에 문화유산 보존 센터의 결제 정책에 따라 티켓 예약 결제를 진행하고, 예약 코드가 발급된 후 결제가 완료됩니다. 고객님이 "결제" 버튼을 클릭하면 예약 정보가 정확한지 확인한 것으로 간주되며, 티켓 구매 거래에 대한 조건이 적용됩니다. </p> 
                <p> 결제 후 예약 확인 이메일을 받게 됩니다. 고객님은 제공된 이메일 주소로 티켓 정보를 확인할 수 있습니다. 확인 이메일이 스팸 메일로 분류될 수 있으니, 스팸 메일함을 확인한 후 후에 문화유산 보존 센터와 연락해 주세요. </p> <p> 등록 과정에서 고객님은 웹사이트에서 발송하는 광고 이메일을 수신하는 데 동의한 것으로 간주됩니다. 이후 수신을 원하지 않으면 이메일 하단의 링크를 통해 수신 거부를 할 수 있습니다. </p> 
                <h5 class="addcart-header ticket-header"> 4. 티켓 가격 </h5> 
                <p> 웹사이트에 게시된 티켓 가격은 최종 가격으로 부가가치세(VAT)가 포함되어 있습니다. 가격은 시점에 따라 다를 수 있으며, 관련 프로모션이 있을 경우 예약 페이지에서 명확히 표시됩니다. </p> <p> 웹사이트에서 예약한 티켓은 성인 및 아동을 위한 가격입니다. 다른 대상 그룹에 대한 티켓은 현장에서 직접 구매해 주세요. </p> <p> 방문 시 신분증 또는 신분증 사진(사진과 생년월일이 포함된)을 지참하여야 합니다. </p> 
                <h5 class="addcart-header ticket-header"> 5. 거래 금액 및 결제 방식 </h5> 
                <p> 후에 문화유산 보존 센터는 국내 카드 결제, 일부 전자 지갑 및 현장 결제 옵션을 제공합니다. </p> <p> 특별히 표시된 경우를 제외하고 고객님은 예약 시 제공된 결제 방법 중 하나를 선택하여 결제를 진행할 수 있습니다. </p> 
                <p>안전한 결제를 보장하기 위해 고객님께서는 다음 사항을 유의해야 합니다:</p> <p class='p-subcontent'> <strong>1.</strong> 후에 문화유산 보존 센터의 웹사이트에서 제공된 결제 창을 통해 온라인 결제를 진행해야 합니다. </p> 
                <p class='p-subcontent'> <strong>2.</strong> 카드(신용카드, ATM 카드, 구매 카드 등) 및 계좌 정보는 안전하게 관리해야 합니다. </p> 
                <p class='p-subcontent'> <strong>3.</strong> 후에 문화유산 보존 센터 웹사이트에서 비정상적인 거래가 발생했을 경우, 즉시 고객 지원 팀에 연락하여 적절한 조치를 취해야 합니다. </p> <p class='p-subcontent'> <strong>4.</strong> 카드 거래 내역을 주기적으로 확인하여 모든 거래가 통제 내에 있는지 확인하세요. </p> 
                <h5 class="addcart-header ticket-header"> 6. 후에 문화유산 보존 센터에서의 거래 성립 </h5> 
                <p> 고객님이 후에 문화유산 보존 센터 웹사이트에서 온라인 티켓을 구매하려면 다음 절차를 따라야 합니다: </p> 
                <p class='p-subcontent'> <strong>1.</strong> 고객님은 방문할 장소를 선택합니다. </p> <p class='p-subcontent'> <strong>2.</strong> 고객님은 방문 인원 수를 선택합니다. </p> 
                <p class='p-subcontent'> <strong>3.</strong> 고객님은 온라인 은행 계좌를 통한 결제 방법으로 결제를 진행합니다. </p> <p class='p-subcontent'> <strong>4.</strong> 결제 후 고객님은 예약 코드를 받게 됩니다. </p> 
                <p class='p-subcontent'> <strong>5.</strong> 고객님은 예약 코드와 개인 정보를 제공하여 방문을 할 수 있습니다. 예약 코드와 개인 정보를 제공하지 않으면 방문이 거부될 수 있습니다. </p> 
                <h5 class="addcart-header ticket-header"> 7. 후에 문화유산 보존 센터에서 예약 변경 및 취소 </h5> <p> 현재 후에 문화유산 보존 센터는 웹사이트에서 성공적으로 결제된 티켓에 대해 취소 또는 변경 서비스를 제공하지 않습니다. </p> <p> 후에 문화유산 보존 센터의 온라인 예약 시스템은 여러 파트너와 연동되어 있으며, 결제 성공 여부는 고객님의 네트워크 연결 상태 및 파트너 기관들의 신호 처리에 따라 달라질 수 있습니다. 결제가 성공적으로 이루어지지 않은 경우, 고객님은 고객 지원 팀에 연락하여 환불을 요청할 수 있습니다. </p> <p> 환불 처리에는 시간이 소요될 수 있으며, 각 카드 유형에 따라 환불 기간이 다를 수 있습니다: </p> <p class='p-subcontent'> <strong>1.</strong> ATM 카드 (국내 카드): 7-15일 (주말 및 공휴일 제외) </p> <p class='p-subcontent'> <strong>2.</strong> 전자 지갑 결제: 5-10일 (주말 및 공휴일 제외) </p> <p class='p-subcontent'> <strong>3.</strong> 환불 기간은 주말 및 공휴일을 제외합니다. </p> <p class='p-subcontent'> <strong>4.</strong> 온라인 티켓 결제 전에 장소, 인원 수 및 관람 대상 정보를 재확인하시기 바랍니다. </p> <h5 class="addcart-header ticket-header"> 8. 상표 및 저작권 </h5> <p> 웹사이트의 모든 지적 재산권(등록된 것과 등록되지 않은 것 포함), 정보 콘텐츠, 디자인, 텍스트, 그래픽, 소프트웨어, 이미지, 영상, 음악, 소리, 소프트웨어 변환, 코드 및 기초 소프트웨어는 후에 문화유산 보존 센터의 자산입니다. 웹사이트의 모든 콘텐츠는 베트남의 지적 재산권 법률 및 베트남이 참여한 국제 협정에 의해 보호됩니다. </p> <h5 class="addcart-header ticket-header"> 9. 적용 법률 및 분쟁 해결 </h5> <p> 본 웹사이트의 조건, 조항 및 내용은 베트남 법에 따라 규정되고 해석됩니다. 본 웹사이트와 관련된 거래에서 발생하는 분쟁은 우선 협상 및 조정을 통해 해결됩니다. 협상이 불가능한 경우, 분쟁은 베트남 법원이 관할하는 법정에서 심리됩니다. </p> <h5 class="addcart-header ticket-header"> 10. 개인정보 보호 규정 </h5> <p> 본 웹사이트는 고객님의 개인정보 보호를 중요시하며, 고객님의 정보를 보호하기 위해 최선의 보안 방법을 사용합니다. 결제 과정에서 고객님의 정보는 암호화되어 안전하게 보호됩니다. 고객님이 주문을 완료한 후, 보안 상태에서 로그아웃됩니다. </p> <p> 고객님은 시스템에 개입하거나 데이터를 변경하는 행위를 금지하며, 이와 관련된 불법 활동은 법적 처벌을 받을 수 있습니다. 모든 거래 정보는 법원이 요구하는 경우를 제외하고는 기밀로 처리됩니다. </p> <h5 class="addcart-header ticket-header"> 11. 상업 정보 입력 오류에 대한 처리 </h5> <p> 고객님은 후에 문화유산 보존 센터에서 거래할 때 정확하고 완전한 정보를 제공할 책임이 있습니다. 예약 정보가 잘못 입력되면 거래가 거부될 수 있습니다. 또한 고객님은 거래를 중단하고 싶을 경우, 후에 문화유산 보존 센터에 연락하여 거래를 취소할 수 있습니다. </p> <h5 class="addcart-header ticket-header"> 12. 계약 해지 규정 </h5> <p> 웹사이트 사용 규정을 위반하여 발생한 손해에 대해 후에 문화유산 보존 센터는 고객님의 계정을 영구히 정지할 수 있습니다. 웹사이트 또는 서비스에 불만족하는 경우, 서비스를 사용하지 않는 것이 유일한 해결책입니다. </p> <p> 고객님은 위 조건을 이해하고 동의한 후 상품을 구매하시기 바랍니다. 추가 정보가 필요하시면 eticket.hueworldheritage.org.vn에서 확인해 주세요. </p>`,
      },
    ],
  },
  {
    id: 23, // HinhThucThanhToan.jsx
    data: [
      {
        no: 0,
        vi: "CHÍNH SÁCH BẢO MẬT THÔNG TIN KHÁCH HÀNG",
        en: "Privacy Policy",
        ko: "고객 개인정보 보호정책",
      },
      {
        no: 1,
        vi: `<p>
                        Chính sách bảo mật này công bố cách thức mà Trung tâm Bảo
                        tồn Di tích Cố đô Huế (Sau đây gọi tắt là “Trung tâm BTDTCĐ”
                        hoặc “Chúng tôi”) thu thập, lưu trữ và xử lý thông tin hoặc
                        dữ liệu cá nhân (“Thông tin cá nhân”) của các Khách hàng của
                        mình thông qua wesite eticket.hueworldheritage.org.vn. Chúng
                        tôi cam kết sẽ bảo mật các Thông tin cá nhân của Khách hàng,
                        sẽ nỗ lực hết sức và sử dụng các biện pháp thích hợp để các
                        thông tin mà Khách hàng cung cấp cho chúng tôi trong quá
                        trình sử dụng website này được bảo mật và bảo vệ khỏi sự
                        truy cập trái phép. Tuy nhiên, Trung tâm BTDTCĐ không đảm
                        bảo ngăn chặn được tất cả các truy cập trái phép. Trong
                        trường hợp truy cập trái phép nằm ngoài khả năng kiểm soát
                        của chúng tôi, Trung tâm BTDTCĐ sẽ không chịu trách nhiệm
                        dưới bất kỳ hình thức nào đối với bất kỳ khiếu nại, tranh
                        chấp hoặc thiệt hại nào phát sinh từ hoặc liên quan đến truy
                        cập trái phép đó. Khách hàng được khuyến nghị để nắm rõ
                        những quyền lợi của mình khi sử dụng các dịch vụ của Trung
                        tâm BTDTCĐ được cung cấp trên website này. Trung tâm BTDTCĐ
                        đưa ra các cam kết dưới đây phù hợp với các quy định của
                        pháp luật Việt Nam, trong đó bao gồm các cách thức mà chúng
                        tôi sử dụng để bảo mật thông tin của Khách hàng.
                    </p>

                    <h5 class="addcart-header ticket-header">
                        1. Mục đích và phạm vi thu thập thông tin
                    </h5>
                    <p>
                        Việc thu thập thông tin cá nhân được thực hiện trên cơ sở
                        khách hàng tự khai báo để đăng ký mua vé tham quan tại
                        website eticket.hueworldheritage.org.vn tùy từng thời điểm,
                        thông tin thu thập sẽ bao gồm nhưng không giới hạn ở:
                    </p>
                    <p class='p-subcontent'>
                        - Thông tin cá nhân như: họ tên, độ tuổi, số CMND.
                    </p>
                    <p class='p-subcontent'>
                        - Thông tin liên lạc như: số điện thoại di động, email.
                    </p>
                    <p class='p-subcontent'>
                        - Các thông tin khác phục vụ cho chương trình khách hàng
                        thân thiết (nếu có).
                    </p>
                    <p>Mục đích thu thập thông tin khách hàng bao gồm:</p>
                    <p class='p-subcontent'>
                        - Cung cấp các dịch vụ, sản phẩm theo nhu cầu của khách hàng
                    </p>
                    <p class='p-subcontent'>
                        - Liên hệ xác nhận khi khách hàng đăng ký sử dụng dịch vụ,
                        xác lập giao dịch trên website
                        eticket.hueworldheritage.org.vn
                    </p>
                    <p class='p-subcontent'>
                        - Thực hiện việc quản lý website
                        eticket.hueworldheritage.org.vn, gửi thông tin cập nhật về
                        website, các chương trình khuyến mại, ưu đãi/tri ân tới
                        khách hàng;
                    </p>
                    <p class='p-subcontent'>
                        - Bảo đảm quyền lợi của khách hàng khi phát hiện các hành
                        động giả mạo, phá hoại tài khoản, lừa đảo khách hàng;
                    </p>
                    <p class='p-subcontent'>
                        - Quản lý, phân tích, đánh giá số liệu để xây dựng chính
                        sách bán và chính sách phục vụ Khách hàng phù hợp;
                    </p>
                    <p class='p-subcontent'>
                        - Tiếp nhận thông tin, góp ý, đề xuất, khiếu nại của Khách
                        hàng nhằm cải thiện chất lượng dịch vụ của Trung tâm BTDTCĐ;
                    </p>
                    <p class='p-subcontent'>
                        - Liên lạc, hỗ trợ, giải quyết với khách hàng trong các
                        trường hợp đặc biệt.
                    </p>
                    <p>
                        Để tránh nghi ngờ, trong quá trình giao dịch thanh toán tại
                        website eticket.hueworldheritage.org.vn, Trung tâm BTDTCĐ
                        chỉ lưu giữ thông tin chi tiết về đơn hàng đã thanh toán của
                        khách hàng, các thông tin về tài khoản ngân hàng của khách
                        hàng sẽ không được lưu giữ.
                    </p>

                    <h5 class="addcart-header ticket-header">
                        2. Phạm vi sử dụng thông tin
                    </h5>
                    <p>
                        Trung tâm BTDTCĐ chỉ sử dụng thông tin cá nhân của khách
                        hàng cho các mục đích quy định tại Mục 1 hoặc mục đích khác
                        (nếu có) với điều kiện đã thông báo và được sự đồng ý của
                        khách hàng.
                    </p>
                    <p>
                        Trung tâm BTDTCĐ sẽ không sử dụng thông tin cá nhân của
                        khách hàng để gửi quảng cáo, giới thiệu dịch vụ và các thông
                        tin có tính thương mại khác khi chưa được khách hàng chấp
                        thuận.
                    </p>
                    <p>
                        Khách hàng hiểu và đồng ý rằng Trung tâm BTDTCĐ có nghĩa vụ
                        phải cung cấp thông tin khách hàng theo yêu cầu/quyết định
                        của Cơ quan nhà nước có thẩm quyền và/hoặc quy định pháp
                        luật. Trung tâm BTDTCĐ sẽ được miễn trừ mọi trách nhiệm liên
                        quan đến bảo mật thông tin trong trường hợp này.
                    </p>

                    <h5 class="addcart-header ticket-header">
                        3. Thời gian lưu trữ thông tin
                    </h5>
                    <p>
                        Dữ liệu cá nhân cơ bản của khách hàng đăng ký mua vé trực
                        tuyến hoặc đăng ký thành viên sẽ được lưu trữ cho đến khi có
                        yêu cầu hủy bỏ hoặc tự thành viên đăng nhập và thực hiện
                        đóng tài khoản. Đối với các tài khoản đã đóng chúng tôi vẫn
                        lưu trữ thông tin cá nhân và truy cập của khách hàng để phục
                        vụ cho mục đích phòng chống gian lận, điều tra, giải đáp
                        thắc mắc ... Các thông tin này sẽ được lưu trữ trong hệ
                        thống máy chủ tối đa mười hai (12) tháng. Hết thời hạn này,
                        chúng tôi sẽ tiến hành xóa vĩnh viễn thông tin cá nhân của
                        khách hàng.
                    </p>

                    <h5 class="addcart-header ticket-header">
                        4. Quyền của Khách hàng đối với các Thông tin cá nhân được
                        thu thập
                    </h5>
                    <p>
                        Bất kỳ Khách hàng nào tự nguyện cung cấp Thông tin cá nhân
                        cho ĐSVN đều có các quyền như sau:
                    </p>
                    <p class='p-subcontent'>
                        - Yêu cầu xem lại các thông tin được thu thập;
                    </p>
                    <p class='p-subcontent'>
                        - Yêu cầu sao chép lại các thông tin được thu thập;
                    </p>
                    <p class='p-subcontent'>
                        - Yêu cầu chỉnh sửa, bổ sung thông tin được thu thập (trực
                        tiếp bằng cách truy cập vào tài khoản của mình trên website
                        của Trung tâm BTDTCĐ hoặc thông qua hệ thống hỗ trợ khách
                        hàng của chúng tôi);
                    </p>
                    <p class='p-subcontent'>
                        - Yêu cầu dừng việc thu thập thông tin;
                    </p>
                    <p class='p-subcontent'>
                        - Yêu cầu xóa các thông tin đã được thu thập.
                    </p>
                    <p class='p-subcontent'>
                        - Khách hàng có thể thực hiện các quyền trên bằng cách tự
                        truy cập vào website hoặc liên hệ với chúng tôi qua email
                        hoặc địa chỉ liên lạc được công bố trên website của Trung
                        tâm BTDTCĐ.
                    </p>
                    <p class='p-subcontent'>
                        - Trường hợp Khách hàng cung cấp cho Trung tâm BTDTCĐ các
                        Thông tin cá nhân không chính xác hoặc không đầy đủ để xác
                        nhận được nhân thân Khách hàng, chúng tôi không thể bảo vệ
                        được quyền bảo mật của Khách hàng theo quy định trên.
                    </p>

                    <h5 class="addcart-header ticket-header">
                        5. Trung tâm BTDTCĐ cam kết
                    </h5>
                    <p>
                        Mọi thông tin cá nhân của khách hàng thu thập được từ
                        website eticket.hueworldheritage.org.vn sẽ được lưu giữ an
                        toàn; chỉ có khách hàng mới có thể truy cập vào tài khoản cá
                        nhân của mình bằng tên đăng nhập và mật khẩu do khách hàng
                        chọn (đối với khách hàng có đăng ký tài khoản truy cập
                        website).
                    </p>
                    <p>
                        Đối với các giao dịch trực tuyến được thực hiện thông qua
                        website eticket.hueworldheritage.org.vn, Trung tâm BTDTCĐ
                        không lưu trữ thông tin thẻ thanh toán của khách hàng. Thông
                        tin tài khoản, thẻ thanh toán của khách hàng sẽ được các đối
                        tác cổng thanh toán của Trung tâm BTDTCĐ bảo vệ theo tiêu
                        chuẩn quốc tế.
                    </p>
                    <p>
                        Khách hàng có nghĩa vụ bảo mật tên đăng ký, mật khẩu và hộp
                        thư điện tử của mình. Trung tâm BTDTCĐ sẽ không chịu trách
                        nhiệm dưới bất kỳ hình thức nào đối với các thiệt hại, tổn
                        thất (nếu có) do khách hàng không tuân thủ quy định bảo mật
                        này.
                    </p>
                    <p>
                        Khách hàng tuyệt đối không được có các hành vi sử dụng công
                        cụ, chương trình để can thiệp trái phép vào hệ thống hay làm
                        thay đổi dữ liệu của Trung tâm BTDTCĐ. Trong trường hợp
                        Trung tâm BTDTCĐ phát hiện khách hàng có hành vi cố tình giả
                        mạo, gian lận, phát tán thông tin cá nhân trái phép … Trung
                        tâm BTDTCĐ có quyền chuyển thông tin cá nhân của khách hàng
                        cho các cơ quan có thẩm quyền để xử lý theo quy định của
                        pháp luật.
                    </p>

                    <h5 class="addcart-header ticket-header">
                        6. Thông tin của Trung tâm
                    </h5>
                    <p>
                        <strong>TRUNG TÂM BẢO TỒN DI TÍCH CỐ ĐÔ HUẾ</strong>
                    </p>
                    <p>Địa chỉ: Tam Toà, 23 Tống Duy Tân – Thành phố Huế</p>
                    <p>Điện thoại: +(84).234.3523237 - 3513322 – 3512751</p>
                    <p>Email: huedisan@gmail.com</p>

                    <h5 class="addcart-header ticket-header">
                        7. Việc cập nhật và ngôn ngữ của Chính sách bảo mật
                    </h5>
                    <p>
                        Trung tâm BTDTCĐ sẽ chỉnh sửa Chính sách bảo mật này vào bất
                        kỳ thời điểm nào khi cần thiết, bản Chính sách bảo mật cập
                        nhật sẽ được công bố trên website của chúng tôi và sẽ được
                        ghi ngày để Khách hàng nhận biết được bản mới nhất.
                    </p>
                    <p>
                        Theo quy định pháp luật, ngôn ngữ được ưu tiên sử dụng và
                        tham chiếu là tiếng Việt. Trong trường hợp có sự mâu thuẫn
                        trong cách giải thích giữa bản tiếng Việt và các ngôn ngữ
                        khác thì bản tiếng Việt sẽ được ưu tiên tham chiếu.
                    </p>
                    <p>
                        Chính sách bảo mật này được cập nhật đến ngày 31 tháng 01
                        năm 2022.
                    </p>`,
        en: `<p>
                    This Privacy Policy outlines how the Hue Monuments Conservation Center (hereinafter referred to as "HMCC" or "We") collects, stores, and processes personal information or data ("Personal Information") of its customers through the website eticket.hueworldheritage.org.vn.

We are committed to safeguarding our customers' personal information and will make every effort to apply appropriate measures to ensure that the information provided to us during the use of this website is protected and secured against unauthorized access.

However, HMCC does not guarantee that all unauthorized access can be prevented. In cases where such access occurs beyond our control, HMCC shall not be held liable under any circumstances for any claims, disputes, or damages arising from or related to such unauthorized access.

Customers are encouraged to understand their rights when using the services provided by HMCC on this website. HMCC makes the following commitments in accordance with the laws of Vietnam, including the methods we use to protect the personal information of our customers.
                    </p>
    
                    <h5 class="addcart-header ticket-header">
                    1. Purpose and Scope of Information Collection
                    </h5>
                    <p>
                    The collection of personal information is carried out based on the customer's voluntary declaration when registering to purchase sightseeing tickets on the website eticket.hueworldheritage.org.vn. Depending on the specific time and purpose, the information collected will include, but is not limited to:
                    </p>
                    <p class='p-subcontent'>
                    - Personal information such as: full name, age, ID card number.
                    </p>
                    <p class='p-subcontent'>
                        - Contact information such as: mobile phone number, email address.
                    </p>
                    <p class='p-subcontent'>
                        - Other information serving the loyalty program (if applicable).
                    </p>
                    <p>The purposes of collecting customer information include:</p>
                    <p class='p-subcontent'>
                        - Provide services and products based on customer needs.
                    </p>
                    <p class='p-subcontent'>
                        - Contact for confirmation when customers register to use services or establish transactions on the website eticket.hueworldheritage.org.vn.
                    </p>
                    <p class='p-subcontent'>
                        - Manage the website eticket.hueworldheritage.org.vn, send updates about the website, promotional programs, offers, and gratitude to customers.
                    </p>
                    <p class='p-subcontent'>
                        - Ensure customer rights when detecting fraudulent actions, account sabotage, or customer scams.
                    </p>
                    <p class='p-subcontent'>
                        - Manage, analyze, and evaluate data to develop appropriate sales policies and customer service policies.
                    </p>
                    <p class='p-subcontent'>
                        - Receive information, feedback, suggestions, and complaints from customers to improve the service quality of the Hue Monuments Conservation Center.
                    </p>
                    <p class='p-subcontent'>
                        - Contact, support, and resolve issues with customers in special cases.
                    </p>
                    <p>
                    To avoid any doubts, during the payment transaction process on the website eticket.hueworldheritage.org.vn, the Hue Monuments Conservation Center only retains details of the customer's paid order. Customer bank account information will not be stored.
                    </p>
    
                    <h5 class="addcart-header ticket-header">
                    2. Scope of Information Use
                    </h5>
                    <p>
                    The Hue Monuments Conservation Center will only use the customer's personal information for the purposes outlined in Section 1 or other purposes (if any), provided that the customer has been informed and given consent.
                    </p>
                    <p>
                    The Hue Monuments Conservation Center will not use the customer's personal information to send advertisements, service promotions, or other commercial information without the customer's consent.
                    </p>
                    <p>
                    The customer understands and agrees that the Hue Monuments Conservation Center is obligated to provide customer information as required or mandated by competent state authorities and/or legal regulations. The Hue Monuments Conservation Center will be exempt from any responsibility related to information security in this case.
                    </p>
    
                    <h5 class="addcart-header ticket-header">
                    3. Retention Period of Information
                    </h5>
                    <p>
                    The basic personal data of customers who register to purchase tickets online or register as members will be stored until a cancellation request is made or the member logs in and deactivates the account. For closed accounts, we will still retain the customer's personal information and access for the purpose of fraud prevention, investigation, inquiries, etc. This information will be stored in the server system for a maximum of twelve (12) months. After this period, we will permanently delete the customer's personal information.
                    </p>
    
                    <h5 class="addcart-header ticket-header">
                    4. Customer Rights Regarding Collected Personal Information
                    </h5>
                    <p>
                    Any customer who voluntarily provides personal information to the Hue Monuments Conservation Center has the following rights:
                    </p>
                    <p class='p-subcontent'>
                    - Request to review the collected information;
                    </p>
                    <p class='p-subcontent'>
                    - Request a copy of the collected information;
                    </p>
                    <p class='p-subcontent'>
                    - Request to edit or supplement the collected information (directly by accessing their account on the Hue Monuments Conservation Center website or through our customer support system);
                    </p>
                    <p class='p-subcontent'>
                    - Request to stop the collection of information;
                    </p>
                    <p class='p-subcontent'>
                    - Request to delete the collected information.
                    </p>
                    <p class='p-subcontent'>
                    - Customers can exercise the above rights by accessing the website themselves or contacting us via email or the contact address provided on the Hue Monuments Conservation Center's website.
                    </p>
                    <p class='p-subcontent'>
                    - In cases where customers provide the Hue Monuments Conservation Center with inaccurate or incomplete personal information that prevents the verification of their identity, we will not be able to protect the customer's privacy rights as outlined above.
                    </p>
    
                    <h5 class="addcart-header ticket-header">
                    5. The Hue Monuments Conservation Center commits
                    </h5>
                    <p>
                    All personal information of customers collected from the website eticket.hueworldheritage.org.vn will be securely stored; only customers will be able to access their personal account using the username and password they have chosen (for customers who have registered an account to access the website).
                    </p>
                    <p>
                    For online transactions made through the website eticket.hueworldheritage.org.vn, the Hue Monuments Conservation Center does not store customer payment card information. Customer account and payment card information will be protected by the payment gateway partners of the Hue Monuments Conservation Center according to international standards.
                    </p>
                    <p>
                    Customers are responsible for keeping their registration name, password, and email account secure. The Hue Monuments Conservation Center will not be liable in any way for any damages or losses (if any) resulting from the customer's failure to comply with this security policy.
                    </p>
                    <p>
                    Customers are strictly prohibited from using tools or programs to unlawfully interfere with the system or alter the data of the Hue Monuments Conservation Center. In the event that the Hue Monuments Conservation Center detects any fraudulent, counterfeiting, or unauthorized dissemination of personal information by the customer, the Center has the right to transfer the customer's personal information to the relevant authorities for legal processing.
                    </p>
    
                    <h5 class="addcart-header ticket-header">
                    6. Information of the Center
                    </h5>
                    <p>
                        <strong>HUE MONUMENTS CONSERVATION CENTER</strong>
                    </p>
                    <p>Address: Tam Toà, 33 Tống Duy Tân – Hue City</p>
                    <p>Phone: +(84).234.3523237 - 3513322 – 3512751</p>
                    <p>Email: huedisan@gmail.com</p>
    
                    <h5 class="addcart-header ticket-header">
                    7. Updates and Language of the Privacy Policy
                    </h5>
                    <p>
                    The Hue Monuments Conservation Center may revise this Privacy Policy at any time as necessary. The updated Privacy Policy will be published on our website and will be dated to allow customers to identify the most recent version.
                    </p>
                    <p>
                    According to legal regulations, the preferred language for use and reference is Vietnamese. In case of any conflict in interpretation between the Vietnamese version and other languages, the Vietnamese version will take precedence.
                    </p>
                    <p>
                    This Privacy Policy was last updated on January 31, 2022.
                    </p>`,
        ko: `<p> 이 개인정보 보호정책은 중남부 유네스코 세계문화유산 보존센터(이하 "중남부 유네스코 보존센터" 또는 "저희")가 eticket.hueworldheritage.org.vn 웹사이트를 통해 고객의 개인정보("개인정보")를 수집, 저장 및 처리하는 방법을 설명합니다. 저희는 고객이 제공한 개인정보를 안전하게 보호하며, 이 웹사이트 사용 중에 제공된 정보가 무단 접근으로부터 보호되도록 최선을 다해 적절한 조치를 취할 것입니다. 그러나 중남부 유네스코 보존센터는 모든 불법적인 접근을 방지할 수는 없습니다. 저희의 통제 범위를 벗어난 불법적인 접근이 발생할 경우, 중남부 유네스코 보존센터는 이에 대해 어떠한 불만, 분쟁 또는 손해에 대해서도 책임을 지지 않습니다. 고객은 이 웹사이트에서 제공되는 서비스를 이용함에 있어 자신의 권리를 충분히 이해하시기 바랍니다. 중남부 유네스코 보존센터는 아래에 명시된 바와 같이 베트남 법률에 따라 고객의 개인정보를 보호하기 위해 노력합니다. </p> <h5 class="addcart-header ticket-header"> 1. 정보 수집의 목적과 범위 </h5> <p> 개인정보 수집은 고객이 eticket.hueworldheritage.org.vn 웹사이트에서 관광 티켓을 구매하기 위해 자발적으로 등록하는 방식으로 이루어집니다. 수집된 정보에는 다음이 포함되며, 이는 제한적이지 않습니다: </p> <p class='p-subcontent'> - 개인 정보: 이름, 나이, 신분증 번호. </p> <p class='p-subcontent'> - 연락처 정보: 휴대폰 번호, 이메일. </p> <p class='p-subcontent'> - 고객 충성도 프로그램(있는 경우)을 위한 기타 정보. </p> <p>고객 정보를 수집하는 목적은 다음과 같습니다:</p> <p class='p-subcontent'> - 고객의 요구에 맞는 서비스 및 상품 제공 </p> <p class='p-subcontent'> - 고객이 서비스 등록 또는 거래 설정 시 확인 연락 </p> <p class='p-subcontent'> - eticket.hueworldheritage.org.vn 웹사이트 관리, 웹사이트 업데이트 및 프로모션, 감사 프로그램 정보 제공 </p> <p class='p-subcontent'> - 고객의 권리 보호 및 사기, 계정 파괴 방지 </p> <p class='p-subcontent'> - 고객에 맞는 판매 및 서비스 정책을 위한 데이터 분석 및 관리 </p> <p class='p-subcontent'> - 서비스 품질 향상을 위한 고객 의견 수렴 </p> <p class='p-subcontent'> - 특별한 경우 고객 지원 및 문제 해결 </p> <p> 결제 과정에서, 중남부 유네스코 보존센터는 고객의 결제 계좌 정보를 저장하지 않으며, 결제된 주문 정보만 저장합니다. </p> <h5 class="addcart-header ticket-header"> 2. 정보 사용 범위 </h5> <p> 중남부 유네스코 보존센터는 고객의 개인정보를 1항에 명시된 목적 외에 다른 목적으로 사용하지 않으며, 고객의 동의를 얻지 않은 상업적 목적의 광고나 서비스 홍보를 하지 않습니다. </p> <p> 고객은 중남부 유네스코 보존센터가 법률에 의해 요구되거나 정부 기관의 결정을 따를 의무가 있음을 이해하고 이에 동의합니다. 이 경우, 중남부 유네스코 보존센터는 정보 보호에 대한 책임을 지지 않습니다. </p> <h5 class="addcart-header ticket-header"> 3. 정보 보관 기간 </h5> <p> 고객이 온라인으로 티켓을 구매하거나 회원으로 등록한 기본 개인정보는 고객이 계정을 삭제하거나 요청할 때까지 저장됩니다. 계정이 삭제된 후에도 고객의 개인정보와 접근 기록은 사기 방지 및 조사, 질의 응답을 위해 12개월 동안 보관됩니다. 이 기간이 지나면 개인정보는 완전히 삭제됩니다. </p> <h5 class="addcart-header ticket-header"> 4. 고객의 개인정보에 대한 권리 </h5> <p> 고객은 제공한 개인정보에 대해 다음과 같은 권리를 가집니다: </p> <p class='p-subcontent'> - 수집된 정보 조회 요청 </p> <p class='p-subcontent'> - 수집된 정보 복사 요청 </p> <p class='p-subcontent'> - 수집된 정보 수정 및 보충 요청 (웹사이트 계정에 직접 접근하거나 고객 지원을 통해) </p> <p class='p-subcontent'> - 수집 중단 요청 </p> <p class='p-subcontent'> - 수집된 정보 삭제 요청 </p> <p class='p-subcontent'> - 고객은 웹사이트에 접근하거나 이메일 또는 중남부 유네스코 보존센터의 공개된 연락처를 통해 이러한 권리를 실현할 수 있습니다. </p> <p class='p-subcontent'> - 고객이 제공한 정보가 부정확하거나 불완전한 경우, 저희는 고객의 개인정보 보호를 보장할 수 없습니다. </p> <h5 class="addcart-header ticket-header"> 5. 중남부 유네스코 보존센터의 약속 </h5> <p> 고객의 개인정보는 eticket.hueworldheritage.org.vn 웹사이트에서 안전하게 보관됩니다. 고객만이 계정 이름과 비밀번호로 자신의 계정에 접근할 수 있습니다. </p> <p> 온라인 거래 중, 중남부 유네스코 보존센터는 고객의 결제 카드 정보를 저장하지 않으며, 고객의 결제 정보는 결제 게이트웨이 파트너에 의해 보호됩니다. </p> <p> 고객은 자신의 계정 이름, 비밀번호 및 이메일을 비밀로 유지할 책임이 있습니다. 이를 따르지 않음으로 발생한 손해에 대해 중남부 유네스코 보존센터는 책임지지 않습니다. </p> <p> 고객은 시스템을 불법적으로 조작하거나 정보를 변경하는 행위를 해서는 안 됩니다. 중남부 유네스코 보존센터는 고객이 부정행위를 저질렀을 경우, 개인정보를 법적 기관에 전달하여 처리할 수 있습니다. </p> <h5 class="addcart-header ticket-header"> 6. 중남부 유네스코 보존센터의 정보 </h5> <p> <strong>중남부 유네스코 세계문화유산 보존센터</strong> </p> <p>주소: Tam Toà, 23 Tống Duy Tân – 후에시, 베트남</p> <p>전화: +(84).234.3523237 - 3513322 – 3512751</p> <p>이메일: huedisan@gmail.com</p> <h5 class="addcart-header ticket-header"> 7. 개인정보 보호정책의 업데이트 및 언어 </h5> <p> 중남부 유네스코 보존센터는 필요에 따라 이 개인정보 보호정책을 수정할 수 있으며, 업데이트된 정책은 웹사이트에 게시되고 날짜가 기재됩니다. </p> <p> 법적으로, 우선적으로 사용되고 참조되는 언어는 베트남어입니다. 베트남어와 다른 언어 간에 해석 차이가 있을 경우, 베트남어 버전이 우선합니다. </p> <p> 이 개인정보 보호정책은 2022년 1월 31일에 마지막으로 업데이트되었습니다. </p>`,
      },
    ],
  },
  {
    id: 24, // .jsx
    data: [
      {
        no: 0,
        vi: "",
        en: "",
        ko: "",
      },
      {
        no: 1,
        vi: "",
        en: "",
        ko: "",
      },
    ],
  },
];

const message = [
  {
    id: 1,
    data: [
      {
        no: 0,
        vi: "Vui lòng chọn vé tham quan",
        en: "Please select your ticket",
        ko: "관람권을 선택해 주세요",
      },
      {
        no: 1,
        vi: "Hãy nhập số lượng vé cần mua",
        en: "Please enter the number of tickets you want to buy",
        ko: "구매할 입장권 수량을 입력하세요",
      },
      {
        no: 2,
        vi: "Hãy nhập số điện thoại",
        en: "Please enter phone number",
        ko: "전화번호를 입력하세요",
      },
      {
        no: 3,
        vi: "Hãy nhập địa chỉ email",
        en: "Please enter email address",
        ko: "이메일 주소를 입력하세요",
      },
      {
        no: 4,
        vi: "Hãy nhập địa chỉ",
        en: "Please enter address",
        ko: "주소를 입력해 주세요",
      },
      {
        no: 5,
        vi: "Hãy chọn phương thức thanh toán online",
        en: "Please select online payment method",
        ko: "온라인 결제 방법을 선택해 주세요",
      },
      {
        no: 6,
        vi: "Hãy nhập đủ số lượng",
        en: "Please enter the required quantity",
        ko: "필요한 수량을 입력해 주세요",
      },
      {
        no: 7,
        vi: "Hãy chọn địa phương đối với khách trong nước",
        en: "Please select a province for domestic visitors",
        ko: "국내 방문객을 위한 지역을 선택해 주세요",
      },
      {
        no: 8,
        vi: "Hãy nhập đầy đủ thông tin cần thiết!",
        en: "Please fill in all required information!",
        ko: "필요한 모든 정보를 입력해 주세요!",
      },
      {
        no: 9,
        vi: "Đã tồn tại thông tin, xin hãy dùng thẻ căn cước khác",
        en: "Information already exists, please use another ID card",
        ko: "정보가 이미 존재합니다. 다른 신분증을 사용해 주세요",
      },
      {
        no: 10,
        vi: "Thông báo",
        en: "Notification",
        ko: "알림",
      },
      {
        no: 11,
        vi: "Quý khách hoàn toàn chịu trách nhiệm về thông tin khai báo khi mua vé ưu tiên, trường hợp phát hiện thông tin sai, quý khách không được đổi trả vé.",
        en: "You are fully responsible for the information declared when purchasing priority tickets. In case of detecting incorrect information, you will not be able to exchange or return the ticket.",
        ko: "우선권 티켓 구매 시 제공한 정보에 대해 전적으로 책임을 지며, 정보 오류가 발견될 경우 티켓을 교환하거나 반환할 수 없습니다.",
      },
      {
        no: 12,
        vi: "Đang có lỗi xảy ra, vui lòng thử lại sau",
        en: "An error occurred, please try again later",
        ko: "오류가 발생했습니다. 잠시 후 다시 시도해 주세요",
      },
      {
        no: 13,
        vi: "Email không đúng định dạng",
        en: "Email is not in correct format",
        ko: "이메일 형식이 올바르지 않습니다",
      },
      {
        no: 14,
        vi: "Gửi email không thành công, vui lòng liên hệ bộ phận phát triển",
        en: "Email sending failed, please contact development department",
        ko: "이메일 발송에 실패했습니다. 개발 부서에 문의해 주세요",
      },
      {
        no: 15,
        vi: "Gửi email thành công! Hãy kiểm tra hộp mail",
        en: "Email sent successfully! Please check your mailbox",
        ko: "이메일이 성공적으로 전송되었습니다! 메일함을 확인해 주세요",
      },
      {
        no: 16,
        vi: "Gửi email thành công!",
        en: "Email sent successfully!",
        ko: "이메일이 성공적으로 전송되었습니다!",
      },
      {
        no: 17,
        vi: "Không thể tạo biên lai điện tử!! Xin hãy liên hệ quản trị viên",
        en: "Unable to create e-receipt!! Please contact administrator",
        ko: "전자 영수증을 생성할 수 없습니다!! 관리자에게 문의해 주세요",
      },
      {
        no: 18,
        vi: "Hãy nhập ít nhất 7 ký tự",
        en: "Please enter at least 7 characters",
        ko: "최소 7자 이상 입력해 주세요",
      },
      {
        no: 19,
        vi: "Hãy chọn địa phương",
        en: "Please choose province",
        ko: "지역을 선택해 주세요",
      },
      {
        no: 20,
        vi: "Hãy chọn quốc tịch",
        en: "Please select your nationality",
        ko: "국적을 선택해 주세요",
      },
      {
        no: 21,
        vi: "Hãy nhập đúng số lượng",
        en: "Please enter the correct quantity",
        ko: "정확한 수량을 입력해 주세요",
      },
      {
        no: 22,
        vi: "Sai số lượng tại",
        en: "Incorrect quantity at",
        ko: "수량 오류 발생",
      },
      {
        no: 23,
        vi: "Năm sinh không phù hợp với loại hình ưu tiên",
        en: "The year of birth does not match the priority category",
        ko: "출생연도가 우대 유형에 적합하지 않습니다",
      },
      {
        no: 24,
        vi: "Lỗi",
        en: "Error",
        ko: "오류",
      },
      {
        no: 25,
        vi: "",
        en: "",
        ko: "",
      },
      {
        no: 26,
        vi: "Vui lòng nhập email",
        en: "Please enter your email",
        ko: "이메일을 입력해 주세요",
      },
      {
        no: 27,
        vi: "Email không hợp lệ",
        en: "Invalid email address",
        ko: "유효하지 않은 이메일 주소입니다",
      },
      {
        no: 28,
        vi: "Vui lòng đợi 60 giây trước khi nhận lại mã OTP",
        en: "Please wait 60 seconds before requesting another OTP.",
        ko: "OTP를 다시 요청하기 전에 60초간 기다려 주세요.",
      },
    ]
  },
  {
    id: 2, //Mã code mess dành cho OTP
    data: [
      {
        no: 0,
        vi: "OTP hết hạn, cần lấy OTP mới",
        en: "OTP has expired. Please request a new OTP.",
        ko: "OTP가 만료되었습니다. 새 OTP를 요청해주세요.",
      },
      {
        no: 1,
        vi: "Gởi OTP thành công",
        en: "OTP sent successfully.",
        ko: "OTP가 성공적으로 전송되었습니다.",
      }, 
      {
        no: 2,
        vi: "Không tồn tại OTP, cần nhập mã OTP",
        en: "OTP does not exist. Please enter the OTP.",
        ko: "OTP가 존재하지 않습니다. OTP를 입력해 주세요.",
      },
    ]
  }
];

const vardict = [
  {
    id: 1,
    data: [
      {
        no: 0,
        vi: "title",
        en: "nameEn",
        ko: "nameKr",
      },
      {
        no: 1,
        vi: "placeName",
        en: "placeNameEn",
        ko: "placeNameKr",
      },
      {
        no: 2,
        vi: "custommerTypeName",
        en: "custommerTypeNameEn",
        ko: "custommerTypeNameKr",
      },
      {
        no: 3,
        vi: "title",
        en: "titleEn",
        ko: "titleKr",
      },
      {
        no: 4,
        vi: "content",
        en: "contentEn",
        ko: "contentKr",
      },
      {
        no: 5,
        vi: "customerTypeName",
        en: "customerTypeNameEn",
        ko: "customerTypeNameKr",
      },
      {
        no: 6,
        vi: "placesName",
        en: "placesNameEn",
        ko: "placesNameKr",
      },
      {
        no: 7,
        vi: "name",
        en: "nameEn",
        ko: "nameKr",
      },
      {
        no: 8,
        vi: "http://hueworldheritage.org.vn/Thong-tin-tham-quan/Gia-ve",
        en: "https://hueworldheritage.org.vn/en-us/Tourism-information/Price",
        ko: "https://hueworldheritage.org.vn/en-us/Tourism-information/Price-Kr",
      },
      {
        no: 9,
        vi: "images/logofooter.png",
        en: "images/logo-footer-en.png",
        ko: "images/logo-footer-kr.png",
      },
      {
        no: 10,
        vi: "65655A97-8457-4C35-90BC-AE6800B2DBB1",
        en: "CA80287B-503C-4694-9291-B2BC00A3C0E4",
        ko: "9A0319E9-5C4E-42E2-9623-B2E300903905",
      },
      {
        no: 11,
        vi: "categoryId=EBB95271-FEDD-4FC3-874B-AE6A00AE66EC&q=nội quy",
        en: "categoryId=3AB6D030-A49E-4504-A563-B2BC00A3AB73",
        ko: "categoryId=DC140D5D-F4F8-48F0-8830-B2E30090DE86",
      },
      {
        no: 12,
        vi: "name",
        en: "nameEn",
        ko: "nameKr",
      },
      {
        no: 13,
        vi: "../../images/Policy.jpg",
        en: "../../images/PolicyEn.jpg",
        ko: "../../images/PolicyKr.jpg",
      },
      {
        no: 14,
        vi: "name",
        en: "nameEn",
        ko: "nameKr",
      },
      {
        no: 15,
        vi: "images/logo.svg",
        en: "images/Logohmcc_en.png",
        ko: "images/Logohmcc_kr.png",
      },
      {
        no: 16,
        vi: "images/icon/hotline.png",
        en: "images/icon/hotline-en.png",
        ko: "images/icon/hotline-kr.png",
      },
      {
        no: 17,
        vi: "",
        en: "",
        ko: "",
      },
      {
        no: 18,
        vi: "placesName",
        en: "placesNameEn",
        ko: "placesNameKr",
      },
    ],
  },
];

export const getTranslation = (id, langCode, type) => {
  if (type == 1) {
    // Find the item by id
    const list = vardict.find((entry) => entry.id === id);

    if (list && list.data) {
      // Return the corresponding language value, default to 'en' if langCode doesn't exist
      const items = list.data.map((item) => item[langCode] || item["vi"]);
      return items;
    }
  }

  if (type == 2) {
    // Find the item by id
    const list = message.find((entry) => entry.id === id);

    if (list && list.data) {
      // Return the corresponding language value, default to 'en' if langCode doesn't exist
      const items = list.data.map((item) => item[langCode] || item["vi"]);
      return items;
    }
  }

  // Find the item by id
  const list = langdict.find((entry) => entry.id === id);

  if (list && list.data) {
    // Return the corresponding language value, default to 'en' if langCode doesn't exist
    const items = list.data.map((item) => item[langCode] || item["vi"]);
    return items;
  }

  return ""; // Return null if no match is found
};
